export const SIC_Code = [
    {
        code: "100",
        desc: "AGRICULTURAL PRODUCTION-CROPS",
    },
    {
        code: "200",
        desc: "AGRICULTURAL PROD-LIVESTOCK & ANIMAL SPECIALTIES",
    },
    {
        code: "700",
        desc: "AGRICULTURAL SERVICES",
    },
    {
        code: "800",
        desc: "FORESTRY",
    },
    {
        code: "900",
        desc: "FISHING, HUNTING AND TRAPPING",
    },
    {
        code: "1000",
        desc: "METAL MINING",
    },
    {
        code: "1040",
        desc: "GOLD AND SILVER ORES",
    },
    {
        code: "1090",
        desc: "MISCELLANEOUS METAL ORES",
    },
    {
        code: "1220",
        desc: "BITUMINOUS COAL & LIGNITE MINING",
    },
    {
        code: "1221",
        desc: "BITUMINOUS COAL & LIGNITE SURFACE MINING",
    },
    {
        code: "1311",
        desc: "CRUDE PETROLEUM & NATURAL GAS",
    },
    {
        code: "1381",
        desc: "DRILLING OIL & GAS WELLS",
    },
    {
        code: "1382",
        desc: "OIL & GAS FIELD EXPLORATION SERVICES",
    },
    {
        code: "1389",
        desc: "OIL & GAS FIELD SERVICES, NEC",
    },
    {
        code: "1400",
        desc: "MINING & QUARRYING OF NONMETALLIC MINERALS (NO FUELS)",
    },
    {
        code: "1520",
        desc: "GENERAL BLDG CONTRACTORS - RESIDENTIAL BLDGS",
    },
    {
        code: "1531",
        desc: "OPERATIVE BUILDERS",
    },
    {
        code: "1540",
        desc: "GENERAL BLDG CONTRACTORS - NONRESIDENTIAL BLDGS",
    },
    {
        code: "1600",
        desc: "HEAVY CONSTRUCTION OTHER THAN BLDG CONST - CONTRACTORS",
    },
    {
        code: "1623",
        desc: "WATER, SEWER, PIPELINE, COMM & POWER LINE CONSTRUCTION",
    },
    {
        code: "1700",
        desc: "CONSTRUCTION - SPECIAL TRADE CONTRACTORS",
    },
    {
        code: "1731",
        desc: "ELECTRICAL WORK",
    },
    {
        code: "2000",
        desc: "FOOD AND KINDRED PRODUCTS",
    },
    {
        code: "2011",
        desc: "MEAT PACKING PLANTS",
    },
    {
        code: "2013",
        desc: "SAUSAGES & OTHER PREPARED MEAT PRODUCTS",
    },
    {
        code: "2015",
        desc: "POULTRY SLAUGHTERING AND PROCESSING",
    },
    {
        code: "2020",
        desc: "DAIRY PRODUCTS",
    },
    {
        code: "2024",
        desc: "ICE CREAM & FROZEN DESSERTS",
    },
    {
        code: "2030",
        desc: "CANNED, FROZEN & PRESERVD FRUIT, VEG & FOOD SPECIALTIES",
    },
    {
        code: "2033",
        desc: "CANNED, FRUITS, VEG, PRESERVES, JAMS & JELLIES",
    },
    {
        code: "2040",
        desc: "GRAIN MILL PRODUCTS",
    },
    {
        code: "2050",
        desc: "BAKERY PRODUCTS",
    },
    {
        code: "2052",
        desc: "COOKIES & CRACKERS",
    },
    {
        code: "2060",
        desc: "SUGAR & CONFECTIONERY PRODUCTS",
    },
    {
        code: "2070",
        desc: "FATS & OILS",
    },
    {
        code: "2080",
        desc: "BEVERAGES",
    },
    {
        code: "2082",
        desc: "MALT BEVERAGES",
    },
    {
        code: "2086",
        desc: "BOTTLED & CANNED SOFT DRINKS & CARBONATED WATERS",
    },
    {
        code: "2090",
        desc: "MISCELLANEOUS FOOD PREPARATIONS & KINDRED PRODUCTS",
    },
    {
        code: "2092",
        desc: "PREPARED FRESH OR FROZEN FISH & SEAFOODS",
    },
    {
        code: "2100",
        desc: "TOBACCO PRODUCTS",
    },
    {
        code: "2111",
        desc: "CIGARETTES",
    },
    {
        code: "2200",
        desc: "TEXTILE MILL PRODUCTS",
    },
    {
        code: "2211",
        desc: "BROADWOVEN FABRIC MILLS, COTTON",
    },
    {
        code: "2221",
        desc: "BROADWOVEN FABRIC MILLS, MAN MADE FIBER & SILK",
    },
    {
        code: "2250",
        desc: "KNITTING MILLS",
    },
    {
        code: "2253",
        desc: "KNIT OUTERWEAR MILLS",
    },
    {
        code: "2273",
        desc: "CARPETS & RUGS",
    },
    {
        code: "2300",
        desc: "APPAREL & OTHER FINISHD PRODS OF FABRICS & SIMILAR MATL",
    },
    {
        code: "2320",
        desc: "MEN'S & BOYS' FURNISHGS, WORK CLOTHG, & ALLIED GARMENTS",
    },
    {
        code: "2330",
        desc: "WOMEN'S, MISSES', AND JUNIORS OUTERWEAR",
    },
    {
        code: "2340",
        desc: "WOMEN'S, MISSES', CHILDREN'S & INFANTS' UNDERGARMENTS",
    },
    {
        code: "2390",
        desc: "MISCELLANEOUS FABRICATED TEXTILE PRODUCTS",
    },
    {
        code: "2400",
        desc: "LUMBER & WOOD PRODUCTS (NO FURNITURE)",
    },
    {
        code: "2421",
        desc: "SAWMILLS & PLANTING MILLS, GENERAL",
    },
    {
        code: "2430",
        desc: "MILLWOOD, VENEER, PLYWOOD, & STRUCTURAL WOOD MEMBERS",
    },
    {
        code: "2451",
        desc: "MOBILE HOMES",
    },
    {
        code: "2452",
        desc: "PREFABRICATED WOOD BLDGS & COMPONENTS",
    },
    {
        code: "2510",
        desc: "HOUSEHOLD FURNITURE",
    },
    {
        code: "2511",
        desc: "WOOD HOUSEHOLD FURNITURE, (NO UPHOLSTERED)",
    },
    {
        code: "2520",
        desc: "OFFICE FURNITURE",
    },
    {
        code: "2522",
        desc: "OFFICE FURNITURE (NO WOOD)",
    },
    {
        code: "2531",
        desc: "PUBLIC BLDG & RELATED FURNITURE",
    },
    {
        code: "2540",
        desc: "PARTITIONS, SHELVG, LOCKERS, & OFFICE & STORE FIXTURES",
    },
    {
        code: "2590",
        desc: "MISCELLANEOUS FURNITURE & FIXTURES",
    },
    {
        code: "2600",
        desc: "PAPERS & ALLIED PRODUCTS",
    },
    {
        code: "2611",
        desc: "PULP MILLS",
    },
    {
        code: "2621",
        desc: "PAPER MILLS",
    },
    {
        code: "2631",
        desc: "PAPERBOARD MILLS",
    },
    {
        code: "2650",
        desc: "PAPERBOARD CONTAINERS & BOXES",
    },
    {
        code: "2670",
        desc: "CONVERTED PAPER & PAPERBOARD PRODS (NO CONTANERS/BOXES)",
    },
    {
        code: "2673",
        desc: "PLASTICS, FOIL & COATED PAPER BAGS",
    },
    {
        code: "2711",
        desc: "NEWSPAPERS: PUBLISHING OR PUBLISHING & PRINTING",
    },
    {
        code: "2721",
        desc: "PERIODICALS: PUBLISHING OR PUBLISHING & PRINTING",
    },
    {
        code: "2731",
        desc: "BOOKS: PUBLISHING OR PUBLISHING & PRINTING",
    },
    {
        code: "2732",
        desc: "BOOK PRINTING",
    },
    {
        code: "2741",
        desc: "MISCELLANEOUS PUBLISHING",
    },
    {
        code: "2750",
        desc: "COMMERCIAL PRINTING",
    },
    {
        code: "2761",
        desc: "MANIFOLD BUSINESS FORMS",
    },
    {
        code: "2771",
        desc: "GREETING CARDS",
    },
    {
        code: "2780",
        desc: "BLANKBOOKS, LOOSELEAF BINDERS & BOOKBINDG & RELATD WORK",
    },
    {
        code: "2790",
        desc: "SERVICE INDUSTRIES FOR THE PRINTING TRADE",
    },
    {
        code: "2800",
        desc: "CHEMICALS & ALLIED PRODUCTS",
    },
    {
        code: "2810",
        desc: "INDUSTRIAL INORGANIC CHEMICALS",
    },
    {
        code: "2820",
        desc: "PLASTIC MATERIAL, SYNTH RESIN/RUBBER, CELLULOS (NO GLASS)",
    },
    {
        code: "2821",
        desc: "PLASTIC MATERIALS, SYNTH RESINS & NONVULCAN ELASTOMERS",
    },
    {
        code: "2833",
        desc: "MEDICINAL CHEMICALS & BOTANICAL PRODUCTS",
    },
    {
        code: "2834",
        desc: "PHARMACEUTICAL PREPARATIONS",
    },
    {
        code: "2835",
        desc: "IN VITRO & IN VIVO DIAGNOSTIC SUBSTANCES",
    },
    {
        code: "2836",
        desc: "BIOLOGICAL PRODUCTS, (NO DISGNOSTIC SUBSTANCES)",
    },
    {
        code: "2840",
        desc: "SOAP, DETERGENTS, CLEANG PREPARATIONS, PERFUMES, COSMETICS",
    },
    {
        code: "2842",
        desc: "SPECIALTY CLEANING, POLISHING AND SANITATION PREPARATIONS",
    },
    {
        code: "2844",
        desc: "PERFUMES, COSMETICS & OTHER TOILET PREPARATIONS",
    },
    {
        code: "2851",
        desc: "PAINTS, VARNISHES, LACQUERS, ENAMELS & ALLIED PRODS",
    },
    {
        code: "2860",
        desc: "INDUSTRIAL ORGANIC CHEMICALS",
    },
    {
        code: "2870",
        desc: "AGRICULTURAL CHEMICALS",
    },
    {
        code: "2890",
        desc: "MISCELLANEOUS CHEMICAL PRODUCTS",
    },
    {
        code: "2891",
        desc: "ADHESIVES & SEALANTS",
    },
    {
        code: "2911",
        desc: "PETROLEUM REFINING",
    },
    {
        code: "2950",
        desc: "ASPHALT PAVING & ROOFING MATERIALS",
    },
    {
        code: "2990",
        desc: "MISCELLANEOUS PRODUCTS OF PETROLEUM & COAL",
    },
    {
        code: "3011",
        desc: "TIRES & INNER TUBES",
    },
    {
        code: "3021",
        desc: "RUBBER & PLASTICS FOOTWEAR",
    },
    {
        code: "3050",
        desc: "GASKETS, PACKG & SEALG DEVICES & RUBBER & PLASTICS HOSE",
    },
    {
        code: "3060",
        desc: "FABRICATED RUBBER PRODUCTS, NEC",
    },
    {
        code: "3080",
        desc: "MISCELLANEOUS PLASTICS PRODUCTS",
    },
    {
        code: "3081",
        desc: "UNSUPPORTED PLASTICS FILM & SHEET",
    },
    {
        code: "3086",
        desc: "PLASTICS FOAM PRODUCTS",
    },
    {
        code: "3089",
        desc: "PLASTICS PRODUCTS, NEC",
    },
    {
        code: "3100",
        desc: "LEATHER & LEATHER PRODUCTS",
    },
    {
        code: "3140",
        desc: "FOOTWEAR, (NO RUBBER)",
    },
    {
        code: "3211",
        desc: "FLAT GLASS",
    },
    {
        code: "3220",
        desc: "GLASS & GLASSWARE, PRESSED OR BLOWN",
    },
    {
        code: "3221",
        desc: "GLASS CONTAINERS",
    },
    {
        code: "3231",
        desc: "GLASS PRODUCTS, MADE OF PURCHASED GLASS",
    },
    {
        code: "3241",
        desc: "CEMENT, HYDRAULIC",
    },
    {
        code: "3250",
        desc: "STRUCTURAL CLAY PRODUCTS",
    },
    {
        code: "3260",
        desc: "POTTERY & RELATED PRODUCTS",
    },
    {
        code: "3270",
        desc: "CONCRETE, GYPSUM & PLASTER PRODUCTS",
    },
    {
        code: "3272",
        desc: "CONCRETE PRODUCTS, EXCEPT BLOCK & BRICK",
    },
    {
        code: "3281",
        desc: "CUT STONE & STONE PRODUCTS",
    },
    {
        code: "3290",
        desc: "ABRASIVE, ASBESTOS & MISC NONMETALLIC MINERAL PRODS",
    },
    {
        code: "3310",
        desc: "STEEL WORKS, BLAST FURNACES & ROLLING & FINISHING MILLS",
    },
    {
        code: "3312",
        desc: "STEEL WORKS, BLAST FURNACES & ROLLING MILLS (COKE OVENS)",
    },
    {
        code: "3317",
        desc: "STEEL PIPE & TUBES",
    },
    {
        code: "3320",
        desc: "IRON & STEEL FOUNDRIES",
    },
    {
        code: "3330",
        desc: "PRIMARY SMELTING & REFINING OF NONFERROUS METALS",
    },
    {
        code: "3334",
        desc: "PRIMARY PRODUCTION OF ALUMINUM",
    },
    {
        code: "3341",
        desc: "SECONDARY SMELTING & REFINING OF NONFERROUS METALS",
    },
    {
        code: "3350",
        desc: "ROLLING DRAWING & EXTRUDING OF NONFERROUS METALS",
    },
    {
        code: "3357",
        desc: "DRAWING & INSULATING OF NONFERROUS WIRE",
    },
    {
        code: "3360",
        desc: "NONFERROUS FOUNDRIES (CASTINGS)",
    },
    {
        code: "3390",
        desc: "MISCELLANEOUS PRIMARY METAL PRODUCTS",
    },
    {
        code: "3411",
        desc: "METAL CANS",
    },
    {
        code: "3412",
        desc: "METAL SHIPPING BARRELS, DRUMS, KEGS & PAILS",
    },
    {
        code: "3420",
        desc: "CUTLERY, HANDTOOLS & GENERAL HARDWARE",
    },
    {
        code: "3430",
        desc: "HEATING EQUIP, EXCEPT ELEC & WARM AIR; & PLUMBING FIXTURES",
    },
    {
        code: "3433",
        desc: "HEATING EQUIPMENT, EXCEPT ELECTRIC & WARM AIR FURNACES",
    },
    {
        code: "3440",
        desc: "FABRICATED STRUCTURAL METAL PRODUCTS",
    },
    {
        code: "3442",
        desc: "METAL DOORS, SASH, FRAMES, MOLDINGS & TRIM",
    },
    {
        code: "3443",
        desc: "FABRICATED PLATE WORK (BOILER SHOPS)",
    },
    {
        code: "3444",
        desc: "SHEET METAL WORK",
    },
    {
        code: "3448",
        desc: "PREFABRICATED METAL BUILDINGS & COMPONENTS",
    },
    {
        code: "3451",
        desc: "SCREW MACHINE PRODUCTS",
    },
    {
        code: "3452",
        desc: "BOLTS, NUTS, SCREWS, RIVETS & WASHERS",
    },
    {
        code: "3460",
        desc: "METAL FORGINGS & STAMPINGS",
    },
    {
        code: "3470",
        desc: "COATING, ENGRAVING & ALLIED SERVICES",
    },
    {
        code: "3480",
        desc: "ORDNANCE & ACCESSORIES, (NO VEHICLES/GUIDED MISSILES)",
    },
    {
        code: "3490",
        desc: "MISCELLANEOUS FABRICATED METAL PRODUCTS",
    },
    {
        code: "3510",
        desc: "ENGINES & TURBINES",
    },
    {
        code: "3523",
        desc: "FARM MACHINERY & EQUIPMENT",
    },
    {
        code: "3524",
        desc: "LAWN & GARDEN TRACTORS & HOME LAWN & GARDENS EQUIP",
    },
    {
        code: "3530",
        desc: "CONSTRUCTION, MINING & MATERIALS HANDLING MACHINERY & EQUIP",
    },
    {
        code: "3531",
        desc: "CONSTRUCTION MACHINERY & EQUIP",
    },
    {
        code: "3532",
        desc: "MINING MACHINERY & EQUIP (NO OIL & GAS FIELD MACH & EQUIP)",
    },
    {
        code: "3533",
        desc: "OIL & GAS FIELD MACHINERY & EQUIPMENT",
    },
    {
        code: "3537",
        desc: "INDUSTRIAL TRUCKS, TRACTORS, TRAILORS & STACKERS",
    },
    {
        code: "3540",
        desc: "METALWORKG MACHINERY & EQUIPMENT",
    },
    {
        code: "3541",
        desc: "MACHINE TOOLS, METAL CUTTING TYPES",
    },
    {
        code: "3550",
        desc: "SPECIAL INDUSTRY MACHINERY (NO METALWORKING MACHINERY)",
    },
    {
        code: "3555",
        desc: "PRINTING TRADES MACHINERY & EQUIPMENT",
    },
    {
        code: "3559",
        desc: "SPECIAL INDUSTRY MACHINERY, NEC",
    },
    {
        code: "3560",
        desc: "GENERAL INDUSTRIAL MACHINERY & EQUIPMENT",
    },
    {
        code: "3561",
        desc: "PUMPS & PUMPING EQUIPMENT",
    },
    {
        code: "3562",
        desc: "BALL & ROLLER BEARINGS",
    },
    {
        code: "3564",
        desc: "INDUSTRIAL & COMMERCIAL FANS & BLOWERS & AIR PURIFING EQUIP",
    },
    {
        code: "3567",
        desc: "INDUSTRIAL PROCESS FURNACES & OVENS",
    },
    {
        code: "3569",
        desc: "GENERAL INDUSTRIAL MACHINERY & EQUIPMENT, NEC",
    },
    {
        code: "3570",
        desc: "COMPUTER & OFFICE EQUIPMENT",
    },
    {
        code: "3571",
        desc: "ELECTRONIC COMPUTERS",
    },
    {
        code: "3572",
        desc: "COMPUTER STORAGE DEVICES",
    },
    {
        code: "3575",
        desc: "COMPUTER TERMINALS",
    },
    {
        code: "3576",
        desc: "COMPUTER COMMUNICATIONS EQUIPMENT",
    },
    {
        code: "3577",
        desc: "COMPUTER PERIPHERAL EQUIPMENT, NEC",
    },
    {
        code: "3578",
        desc: "CALCULATING & ACCOUNTING MACHINES (NO ELECTRONIC COMPUTERS)",
    },
    {
        code: "3579",
        desc: "OFFICE MACHINES, NEC",
    },
    {
        code: "3580",
        desc: "REFRIGERATION & SERVICE INDUSTRY MACHINERY",
    },
    {
        code: "3585",
        desc: "AIR-COND & WARM AIR HEATG EQUIP & COMM & INDL REFRIG EQUIP",
    },
    {
        code: "3590",
        desc: "MISC INDUSTRIAL & COMMERCIAL MACHINERY & EQUIPMENT",
    },
    {
        code: "3600",
        desc: "ELECTRONIC & OTHER ELECTRICAL EQUIPMENT (NO COMPUTER EQUIP)",
    },
    {
        code: "3612",
        desc: "POWER, DISTRIBUTION & SPECIALTY TRANSFORMERS",
    },
    {
        code: "3613",
        desc: "SWITCHGEAR & SWITCHBOARD APPARATUS",
    },
    {
        code: "3620",
        desc: "ELECTRICAL INDUSTRIAL APPARATUS",
    },
    {
        code: "3621",
        desc: "MOTORS & GENERATORS",
    },
    {
        code: "3630",
        desc: "HOUSEHOLD APPLIANCES",
    },
    {
        code: "3634",
        desc: "ELECTRIC HOUSEWARES & FANS",
    },
    {
        code: "3640",
        desc: "ELECTRIC LIGHTING & WIRING EQUIPMENT",
    },
    {
        code: "3651",
        desc: "HOUSEHOLD AUDIO & VIDEO EQUIPMENT",
    },
    {
        code: "3652",
        desc: "PHONOGRAPH RECORDS & PRERECORDED AUDIO TAPES & DISKS",
    },
    {
        code: "3661",
        desc: "TELEPHONE & TELEGRAPH APPARATUS",
    },
    {
        code: "3663",
        desc: "RADIO & TV BROADCASTING & COMMUNICATIONS EQUIPMENT",
    },
    {
        code: "3669",
        desc: "COMMUNICATIONS EQUIPMENT, NEC",
    },
    {
        code: "3670",
        desc: "ELECTRONIC COMPONENTS & ACCESSORIES",
    },
    {
        code: "3672",
        desc: "PRINTED CIRCUIT BOARDS",
    },
    {
        code: "3674",
        desc: "SEMICONDUCTORS & RELATED DEVICES",
    },
    {
        code: "3677",
        desc: "ELECTRONIC COILS, TRANSFORMERS & OTHER INDUCTORS",
    },
    {
        code: "3678",
        desc: "ELECTRONIC CONNECTORS",
    },
    {
        code: "3679",
        desc: "ELECTRONIC COMPONENTS, NEC",
    },
    {
        code: "3690",
        desc: "MISCELLANEOUS ELECTRICAL MACHINERY, EQUIPMENT & SUPPLIES",
    },
    {
        code: "3695",
        desc: "MAGNETIC & OPTICAL RECORDING MEDIA",
    },
    {
        code: "3711",
        desc: "MOTOR VEHICLES & PASSENGER CAR BODIES",
    },
    {
        code: "3713",
        desc: "TRUCK & BUS BODIES",
    },
    {
        code: "3714",
        desc: "MOTOR VEHICLE PARTS & ACCESSORIES",
    },
    {
        code: "3715",
        desc: "TRUCK TRAILERS",
    },
    {
        code: "3716",
        desc: "MOTOR HOMES",
    },
    {
        code: "3720",
        desc: "AIRCRAFT & PARTS",
    },
    {
        code: "3721",
        desc: "AIRCRAFT",
    },
    {
        code: "3724",
        desc: "AIRCRAFT ENGINES & ENGINE PARTS",
    },
    {
        code: "3728",
        desc: "AIRCRAFT PARTS & AUXILIARY EQUIPMENT, NEC",
    },
    {
        code: "3730",
        desc: "SHIP & BOAT BUILDING & REPAIRING",
    },
    {
        code: "3743",
        desc: "RAILROAD EQUIPMENT",
    },
    {
        code: "3751",
        desc: "MOTORCYCLES, BICYCLES & PARTS",
    },
    {
        code: "3760",
        desc: "GUIDED MISSILES & SPACE VEHICLES & PARTS",
    },
    {
        code: "3790",
        desc: "MISCELLANEOUS TRANSPORTATION EQUIPMENT",
    },
    {
        code: "3812",
        desc: "SEARCH, DETECTION, NAVAGATION, GUIDANCE, AERONAUTICAL SYS",
    },
    {
        code: "3821",
        desc: "LABORATORY APPARATUS & FURNITURE",
    },
    {
        code: "3822",
        desc: "AUTO CONTROLS FOR REGULATING RESIDENTIAL & COMML ENVIRONMENTS",
    },
    {
        code: "3823",
        desc: "INDUSTRIAL INSTRUMENTS FOR MEASUREMENT, DISPLAY, AND CONTROL",
    },
    {
        code: "3824",
        desc: "TOTALIZING FLUID METERS & COUNTING DEVICES",
    },
    {
        code: "3825",
        desc: "INSTRUMENTS FOR MEAS & TESTING OF ELECTRICITY & ELEC SIGNALS",
    },
    {
        code: "3826",
        desc: "LABORATORY ANALYTICAL INSTRUMENTS",
    },
    {
        code: "3827",
        desc: "OPTICAL INSTRUMENTS & LENSES",
    },
    {
        code: "3829",
        desc: "MEASURING & CONTROLLING DEVICES, NEC",
    },
    {
        code: "3841",
        desc: "SURGICAL & MEDICAL INSTRUMENTS & APPARATUS",
    },
    {
        code: "3842",
        desc: "ORTHOPEDIC, PROSTHETIC & SURGICAL APPLIANCES & SUPPLIES",
    },
    {
        code: "3843",
        desc: "DENTAL EQUIPMENT & SUPPLIES",
    },
    {
        code: "3844",
        desc: "X-RAY APPARATUS & TUBES & RELATED IRRADIATION APPARATUS",
    },
    {
        code: "3845",
        desc: "ELECTROMEDICAL & ELECTROTHERAPEUTIC APPARATUS",
    },
    {
        code: "3851",
        desc: "OPHTHALMIC GOODS",
    },
    {
        code: "3861",
        desc: "PHOTOGRAPHIC EQUIPMENT & SUPPLIES",
    },
    {
        code: "3873",
        desc: "WATCHES, CLOCKS, CLOCKWORK OPERATED DEVICES/PARTS",
    },
    {
        code: "3910",
        desc: "JEWELRY, SILVERWARE & PLATED WARE",
    },
    {
        code: "3911",
        desc: "JEWELRY, PRECIOUS METAL",
    },
    {
        code: "3931",
        desc: "MUSICAL INSTRUMENTS",
    },
    {
        code: "3942",
        desc: "DOLLS & STUFFED TOYS",
    },
    {
        code: "3944",
        desc: "GAMES, TOYS & CHILDREN'S VEHICLES (NO DOLLS & BICYCLES)",
    },
    {
        code: "3949",
        desc: "SPORTING & ATHLETIC GOODS, NEC",
    },
    {
        code: "3950",
        desc: "PENS, PENCILS & OTHER ARTISTS' MATERIALS",
    },
    {
        code: "3960",
        desc: "COSTUME JEWELRY & NOVELTIES",
    },
    {
        code: "3990",
        desc: "MISCELLANEOUS MANUFACTURING INDUSTRIES",
    },
    {
        code: "4011",
        desc: "RAILROADS, LINE-HAUL OPERATING",
    },
    {
        code: "4013",
        desc: "RAILROAD SWITCHING & TERMINAL ESTABLISHMENTS",
    },
    {
        code: "4100",
        desc: "LOCAL & SUBURBAN TRANSIT & INTERURBAN HWY PASSENGER TRANS",
    },
    {
        code: "4210",
        desc: "TRUCKING & COURIER SERVICES (NO AIR)",
    },
    {
        code: "4213",
        desc: "TRUCKING (NO LOCAL)",
    },
    {
        code: "4220",
        desc: "PUBLIC WAREHOUSING & STORAGE",
    },
    {
        code: "4231",
        desc: "TERMINAL MAINTENANCE FACILITIES FOR MOTOR FREIGHT TRANSPORT",
    },
    {
        code: "4400",
        desc: "WATER TRANSPORTATION",
    },
    {
        code: "4412",
        desc: "DEEP SEA FOREIGN TRANSPORTATION OF FREIGHT",
    },
    {
        code: "4512",
        desc: "AIR TRANSPORTATION, SCHEDULED",
    },
    {
        code: "4513",
        desc: "AIR COURIER SERVICES",
    },
    {
        code: "4522",
        desc: "AIR TRANSPORTATION, NONSCHEDULED",
    },
    {
        code: "4581",
        desc: "AIRPORTS, FLYING FIELDS & AIRPORT TERMINAL SERVICES",
    },
    {
        code: "4610",
        desc: "PIPE LINES (NO NATURAL GAS)",
    },
    {
        code: "4700",
        desc: "TRANSPORTATION SERVICES",
    },
    {
        code: "4731",
        desc: "ARRANGEMENT OF TRANSPORTATION OF FREIGHT & CARGO",
    },
    {
        code: "4812",
        desc: "RADIOTELEPHONE COMMUNICATIONS",
    },
    {
        code: "4813",
        desc: "TELEPHONE COMMUNICATIONS (NO RADIOTELEPHONE)",
    },
    {
        code: "4822",
        desc: "TELEGRAPH & OTHER MESSAGE COMMUNICATIONS",
    },
    {
        code: "4832",
        desc: "RADIO BROADCASTING STATIONS",
    },
    {
        code: "4833",
        desc: "TELEVISION BROADCASTING STATIONS",
    },
    {
        code: "4841",
        desc: "CABLE & OTHER PAY TELEVISION SERVICES",
    },
    {
        code: "4899",
        desc: "COMMUNICATIONS SERVICES, NEC",
    },
    {
        code: "4900",
        desc: "ELECTRIC, GAS & SANITARY SERVICES",
    },
    {
        code: "4911",
        desc: "ELECTRIC SERVICES",
    },
    {
        code: "4922",
        desc: "NATURAL GAS TRANSMISSION",
    },
    {
        code: "4923",
        desc: "NATURAL GAS TRANSMISISON & DISTRIBUTION",
    },
    {
        code: "4924",
        desc: "NATURAL GAS DISTRIBUTION",
    },
    {
        code: "4931",
        desc: "ELECTRIC & OTHER SERVICES COMBINED",
    },
    {
        code: "4932",
        desc: "GAS & OTHER SERVICES COMBINED",
    },
    {
        code: "4941",
        desc: "WATER SUPPLY",
    },
    {
        code: "4950",
        desc: "SANITARY SERVICES",
    },
    {
        code: "4953",
        desc: "REFUSE SYSTEMS",
    },
    {
        code: "4955",
        desc: "HAZARDOUS WASTE MANAGEMENT",
    },
    {
        code: "4961",
        desc: "STEAM & AIR-CONDITIONING SUPPLY",
    },
    {
        code: "4991",
        desc: "COGENERATION SERVICES & SMALL POWER PRODUCERS",
    },
    {
        code: "5000",
        desc: "WHOLESALE-DURABLE GOODS",
    },
    {
        code: "5010",
        desc: "WHOLESALE-MOTOR VEHICLES & MOTOR VEHICLE PARTS & SUPPLIES",
    },
    {
        code: "5013",
        desc: "WHOLESALE-MOTOR VEHICLE SUPPLIES & NEW PARTS",
    },
    {
        code: "5020",
        desc: "WHOLESALE-FURNITURE & HOME FURNISHINGS",
    },
    {
        code: "5030",
        desc: "WHOLESALE-LUMBER & OTHER CONSTRUCTION MATERIALS",
    },
    {
        code: "5031",
        desc: "WHOLESALE-LUMBER, PLYWOOD, MILLWORK & WOOD PANELS",
    },
    {
        code: "5040",
        desc: "WHOLESALE-PROFESSIONAL & COMMERCIAL EQUIPMENT & SUPPLIES",
    },
    {
        code: "5045",
        desc: "WHOLESALE-COMPUTERS & PERIPHERAL EQUIPMENT & SOFTWARE",
    },
    {
        code: "5047",
        desc: "WHOLESALE-MEDICAL, DENTAL & HOSPITAL EQUIPMENT & SUPPLIES",
    },
    {
        code: "5050",
        desc: "WHOLESALE-METALS & MINERALS (NO PETROLEUM)",
    },
    {
        code: "5051",
        desc: "WHOLESALE-METALS SERVICE CENTERS & OFFICES",
    },
    {
        code: "5063",
        desc: "WHOLESALE-ELECTRICAL APPARATUS & EQUIPMENT, WIRING SUPPLIES",
    },
    {
        code: "5064",
        desc: "WHOLESALE-ELECTRICAL APPLIANCES, TV & RADIO SETS",
    },
    {
        code: "5065",
        desc: "WHOLESALE-ELECTRONIC PARTS & EQUIPMENT, NEC",
    },
    {
        code: "5070",
        desc: "WHOLESALE-HARDWARE & PLUMBING & HEATING EQUIPMENT & SUPPLIES",
    },
    {
        code: "5072",
        desc: "WHOLESALE-HARDWARE",
    },
    {
        code: "5080",
        desc: "WHOLESALE-MACHINERY, EQUIPMENT & SUPPLIES",
    },
    {
        code: "5082",
        desc: "WHOLESALE-CONSTRUCTION & MINING (NO PETRO) MACHINERY & EQUIP",
    },
    {
        code: "5084",
        desc: "WHOLESALE-INDUSTRIAL MACHINERY & EQUIPMENT",
    },
    {
        code: "5090",
        desc: "WHOLESALE-MISC DURABLE GOODS",
    },
    {
        code: "5094",
        desc: "WHOLESALE-JEWELRY, WATCHES, PRECIOUS STONES & METALS",
    },
    {
        code: "5099",
        desc: "WHOLESALE-DURABLE GOODS, NEC",
    },
    {
        code: "5110",
        desc: "WHOLESALE-PAPER & PAPER PRODUCTS",
    },
    {
        code: "5122",
        desc: "WHOLESALE-DRUGS, PROPRIETARIES & DRUGGISTS' SUNDRIES",
    },
    {
        code: "5130",
        desc: "WHOLESALE-APPAREL, PIECE GOODS & NOTIONS",
    },
    {
        code: "5140",
        desc: "WHOLESALE-GROCERIES & RELATED PRODUCTS",
    },
    {
        code: "5141",
        desc: "WHOLESALE-GROCERIES, GENERAL LINE",
    },
    {
        code: "5150",
        desc: "WHOLESALE-FARM PRODUCT RAW MATERIALS",
    },
    {
        code: "5160",
        desc: "WHOLESALE-CHEMICALS & ALLIED PRODUCTS",
    },
    {
        code: "5171",
        desc: "WHOLESALE-PETROLEUM BULK STATIONS & TERMINALS",
    },
    {
        code: "5172",
        desc: "WHOLESALE-PETROLEUM & PETROLEUM PRODUCTS (NO BULK STATIONS)",
    },
    {
        code: "5180",
        desc: "WHOLESALE-BEER, WINE & DISTILLED ALCOHOLIC BEVERAGES",
    },
    {
        code: "5190",
        desc: "WHOLESALE-MISCELLANEOUS NONDURABLE GOODS",
    },
    {
        code: "5200",
        desc: "RETAIL-BUILDING MATERIALS, HARDWARE, GARDEN SUPPLY",
    },
    {
        code: "5211",
        desc: "RETAIL-LUMBER & OTHER BUILDING MATERIALS DEALERS",
    },
    {
        code: "5271",
        desc: "RETAIL-MOBILE HOME DEALERS",
    },
    {
        code: "5311",
        desc: "RETAIL-DEPARTMENT STORES",
    },
    {
        code: "5331",
        desc: "RETAIL-VARIETY STORES",
    },
    {
        code: "5399",
        desc: "RETAIL-MISC GENERAL MERCHANDISE STORES",
    },
    {
        code: "5400",
        desc: "RETAIL-FOOD STORES",
    },
    {
        code: "5411",
        desc: "RETAIL-GROCERY STORES",
    },
    {
        code: "5412",
        desc: "RETAIL-CONVENIENCE STORES",
    },
    {
        code: "5500",
        desc: "RETAIL-AUTO DEALERS & GASOLINE STATIONS",
    },
    {
        code: "5531",
        desc: "RETAIL-AUTO & HOME SUPPLY STORES",
    },
    {
        code: "5600",
        desc: "RETAIL-APPAREL & ACCESSORY STORES",
    },
    {
        code: "5621",
        desc: "RETAIL-WOMEN'S CLOTHING STORES",
    },
    {
        code: "5651",
        desc: "RETAIL-FAMILY CLOTHING STORES",
    },
    {
        code: "5661",
        desc: "RETAIL-SHOE STORES",
    },
    {
        code: "5700",
        desc: "RETAIL-HOME FURNITURE, FURNISHINGS & EQUIPMENT STORES",
    },
    {
        code: "5712",
        desc: "RETAIL-FURNITURE STORES",
    },
    {
        code: "5731",
        desc: "RETAIL-RADIO, TV & CONSUMER ELECTRONICS STORES",
    },
    {
        code: "5734",
        desc: "RETAIL-COMPUTER & COMPUTER SOFTWARE STORES",
    },
    {
        code: "5735",
        desc: "RETAIL-RECORD & PRERECORDED TAPE STORES",
    },
    {
        code: "5810",
        desc: "RETAIL-EATING & DRINKING PLACES",
    },
    {
        code: "5812",
        desc: "RETAIL-EATING PLACES",
    },
    {
        code: "5900",
        desc: "RETAIL-MISCELLANEOUS RETAIL",
    },
    {
        code: "5912",
        desc: "RETAIL-DRUG STORES AND PROPRIETARY STORES",
    },
    {
        code: "5940",
        desc: "RETAIL-MISCELLANEOUS SHOPPING GOODS STORES",
    },
    {
        code: "5944",
        desc: "RETAIL-JEWELRY STORES",
    },
    {
        code: "5945",
        desc: "RETAIL-HOBBY, TOY & GAME SHOPS",
    },
    {
        code: "5960",
        desc: "RETAIL-NONSTORE RETAILERS",
    },
    {
        code: "5961",
        desc: "RETAIL-CATALOG & MAIL-ORDER HOUSES",
    },
    {
        code: "5990",
        desc: "RETAIL-RETAIL STORES, NEC",
    },
    {
        code: "6021",
        desc: "NATIONAL COMMERCIAL BANKS",
    },
    {
        code: "6022",
        desc: "STATE COMMERCIAL BANKS",
    },
    {
        code: "6029",
        desc: "COMMERCIAL BANKS, NEC",
    },
    {
        code: "6035",
        desc: "SAVINGS INSTITUTION, FEDERALLY CHARTERED",
    },
    {
        code: "6036",
        desc: "SAVINGS INSTITUTIONS, NOT FEDERALLY CHARTERED",
    },
    {
        code: "6099",
        desc: "FUNCTIONS RELATED TO DEPOSITORY BANKING, NEC",
    },
    {
        code: "6111",
        desc: "FEDERAL & FEDERALLY-SPONSORED CREDIT AGENCIES",
    },
    {
        code: "6141",
        desc: "PERSONAL CREDIT INSTITUTIONS",
    },
    {
        code: "6153",
        desc: "SHORT-TERM BUSINESS CREDIT INSTITUTIONS",
    },
    {
        code: "6159",
        desc: "MISCELLANEOUS BUSINESS CREDIT INSTITUTION",
    },
    {
        code: "6162",
        desc: "MORTGAGE BANKERS & LOAN CORRESPONDENTS",
    },
    {
        code: "6163",
        desc: "LOAN BROKERS",
    },
    {
        code: "6172",
        desc: "FINANCE LESSORS",
    },
    {
        code: "6189",
        desc: "ASSET-BACKED SECURITIES",
    },
    {
        code: "6199",
        desc: "FINANCE SERVICES",
    },
    {
        code: "6200",
        desc: "SECURITY & COMMODITY BROKERS, DEALERS, EXCHANGES & SERVICES",
    },
    {
        code: "6211",
        desc: "SECURITY BROKERS, DEALERS & FLOTATION COMPANIES",
    },
    {
        code: "6221",
        desc: "COMMODITY CONTRACTS BROKERS & DEALERS",
    },
    {
        code: "6282",
        desc: "INVESTMENT ADVICE",
    },
    {
        code: "6311",
        desc: "LIFE INSURANCE",
    },
    {
        code: "6321",
        desc: "ACCIDENT & HEALTH INSURANCE",
    },
    {
        code: "6324",
        desc: "HOSPITAL & MEDICAL SERVICE PLANS",
    },
    {
        code: "6331",
        desc: "FIRE, MARINE & CASUALTY INSURANCE",
    },
    {
        code: "6351",
        desc: "SURETY INSURANCE",
    },
    {
        code: "6361",
        desc: "TITLE INSURANCE",
    },
    {
        code: "6399",
        desc: "INSURANCE CARRIERS, NEC",
    },
    {
        code: "6411",
        desc: "INSURANCE AGENTS, BROKERS & SERVICE",
    },
    {
        code: "6500",
        desc: "REAL ESTATE",
    },
    {
        code: "6510",
        desc: "REAL ESTATE OPERATORS (NO DEVELOPERS) & LESSORS",
    },
    {
        code: "6512",
        desc: "OPERATORS OF NONRESIDENTIAL BUILDINGS",
    },
    {
        code: "6513",
        desc: "OPERATORS OF APARTMENT BUILDINGS",
    },
    {
        code: "6519",
        desc: "LESSORS OF REAL PROPERTY, NEC",
    },
    {
        code: "6531",
        desc: "REAL ESTATE AGENTS & MANAGERS (FOR OTHERS)",
    },
    {
        code: "6532",
        desc: "REAL ESTATE DEALERS (FOR THEIR OWN ACCOUNT)",
    },
    {
        code: "6552",
        desc: "LAND SUBDIVIDERS & DEVELOPERS (NO CEMETERIES)",
    },
    {
        code: "6770",
        desc: "BLANK CHECKS",
    },
    {
        code: "6792",
        desc: "OIL ROYALTY TRADERS",
    },
    {
        code: "6794",
        desc: "PATENT OWNERS & LESSORS",
    },
    {
        code: "6795",
        desc: "MINERAL ROYALTY TRADERS",
    },
    {
        code: "6798",
        desc: "REAL ESTATE INVESTMENT TRUSTS",
    },
    {
        code: "6799",
        desc: "INVESTORS, NEC",
    },
    {
        code: "7000",
        desc: "HOTELS, ROOMING HOUSES, CAMPS & OTHER LODGING PLACES",
    },
    {
        code: "7011",
        desc: "HOTELS & MOTELS",
    },
    {
        code: "7200",
        desc: "SERVICES-PERSONAL SERVICES",
    },
    {
        code: "7310",
        desc: "SERVICES-ADVERTISING",
    },
    {
        code: "7311",
        desc: "SERVICES-ADVERTISING AGENCIES",
    },
    {
        code: "7320",
        desc: "SERVICES-CONSUMER CREDIT REPORTING, COLLECTION AGENCIES",
    },
    {
        code: "7330",
        desc: "SERVICES-MAILING, REPRODUCTION, COMMERCIAL ART & PHOTOGRAPHY",
    },
    {
        code: "7331",
        desc: "SERVICES-DIRECT MAIL ADVERTISING SERVICES",
    },
    {
        code: "7340",
        desc: "SERVICES-TO DWELLINGS & OTHER BUILDINGS",
    },
    {
        code: "7350",
        desc: "SERVICES-MISCELLANEOUS EQUIPMENT RENTAL & LEASING",
    },
    {
        code: "7359",
        desc: "SERVICES-EQUIPMENT RENTAL & LEASING, NEC",
    },
    {
        code: "7361",
        desc: "SERVICES-EMPLOYMENT AGENCIES",
    },
    {
        code: "7363",
        desc: "SERVICES-HELP SUPPLY SERVICES",
    },
    {
        code: "7370",
        desc: "SERVICES-COMPUTER PROGRAMMING, DATA PROCESSING, ETC.",
    },
    {
        code: "7371",
        desc: "SERVICES-COMPUTER PROGRAMMING SERVICES",
    },
    {
        code: "7372",
        desc: "SERVICES-PREPACKAGED SOFTWARE",
    },
    {
        code: "7373",
        desc: "SERVICES-COMPUTER INTEGRATED SYSTEMS DESIGN",
    },
    {
        code: "7374",
        desc: "SERVICES-COMPUTER PROCESSING & DATA PREPARATION",
    },
    {
        code: "7377",
        desc: "SERVICES-COMPUTER RENTAL & LEASING",
    },
    {
        code: "7380",
        desc: "SERVICES-MISCELLANEOUS BUSINESS SERVICES",
    },
    {
        code: "7381",
        desc: "SERVICES-DETECTIVE, GUARD & ARMORED CAR SERVICES",
    },
    {
        code: "7384",
        desc: "SERVICES-PHOTOFINISHING LABORATORIES",
    },
    {
        code: "7385",
        desc: "SERVICES-TELEPHONE INTERCONNECT SYSTEMS",
    },
    {
        code: "7389",
        desc: "SERVICES-BUSINESS SERVICES, NEC",
    },
    {
        code: "7500",
        desc: "SERVICES-AUTOMOTIVE REPAIR, SERVICES & PARKING",
    },
    {
        code: "7510",
        desc: "SERVICES-AUTO RENTAL & LEASING (NO DRIVERS)",
    },
    {
        code: "7600",
        desc: "SERVICES-MISCELLANEOUS REPAIR SERVICES",
    },
    {
        code: "7812",
        desc: "SERVICES-MOTION PICTURE & VIDEO TAPE PRODUCTION",
    },
    {
        code: "7819",
        desc: "SERVICES-ALLIED TO MOTION PICTURE PRODUCTION",
    },
    {
        code: "7822",
        desc: "SERVICES-MOTION PICTURE & VIDEO TAPE DISTRIBUTION",
    },
    {
        code: "7829",
        desc: "SERVICES-ALLIED TO MOTION PICTURE DISTRIBUTION",
    },
    {
        code: "7830",
        desc: "SERVICES-MOTION PICTURE THEATERS",
    },
    {
        code: "7841",
        desc: "SERVICES-VIDEO TAPE RENTAL",
    },
    {
        code: "7900",
        desc: "SERVICES-AMUSEMENT & RECREATION SERVICES",
    },
    {
        code: "7948",
        desc: "SERVICES-RACING, INCLUDING TRACK OPERATION",
    },
    {
        code: "7990",
        desc: "SERVICES-MISCELLANEOUS AMUSEMENT & RECREATION",
    },
    {
        code: "7997",
        desc: "SERVICES-MEMBERSHIP SPORTS & RECREATION CLUBS",
    },
    {
        code: "8000",
        desc: "SERVICES-HEALTH SERVICES",
    },
    {
        code: "8011",
        desc: "SERVICES-OFFICES & CLINICS OF DOCTORS OF MEDICINE",
    },
    {
        code: "8050",
        desc: "SERVICES-NURSING & PERSONAL CARE FACILITIES",
    },
    {
        code: "8051",
        desc: "SERVICES-SKILLED NURSING CARE FACILITIES",
    },
    {
        code: "8060",
        desc: "SERVICES-HOSPITALS",
    },
    {
        code: "8062",
        desc: "SERVICES-GENERAL MEDICAL & SURGICAL HOSPITALS, NEC",
    },
    {
        code: "8071",
        desc: "SERVICES-MEDICAL LABORATORIES",
    },
    {
        code: "8082",
        desc: "SERVICES-HOME HEALTH CARE SERVICES",
    },
    {
        code: "8090",
        desc: "SERVICES-MISC HEALTH & ALLIED SERVICES, NEC",
    },
    {
        code: "8093",
        desc: "SERVICES-SPECIALTY OUTPATIENT FACILITIES, NEC",
    },
    {
        code: "8111",
        desc: "SERVICES-LEGAL SERVICES",
    },
    {
        code: "8200",
        desc: "SERVICES-EDUCATIONAL SERVICES",
    },
    {
        code: "8300",
        desc: "SERVICES-SOCIAL SERVICES",
    },
    {
        code: "8351",
        desc: "SERVICES-CHILD DAY CARE SERVICES",
    },
    {
        code: "8600",
        desc: "SERVICES-MEMBERSHIP ORGANIZATIONS",
    },
    {
        code: "8700",
        desc: "SERVICES-ENGINEERING, ACCOUNTING, RESEARCH, MANAGEMENT",
    },
    {
        code: "8711",
        desc: "SERVICES-ENGINEERING SERVICES",
    },
    {
        code: "8731",
        desc: "SERVICES-COMMERCIAL PHYSICAL & BIOLOGICAL RESEARCH",
    },
    {
        code: "8734",
        desc: "SERVICES-TESTING LABORATORIES",
    },
    {
        code: "8741",
        desc: "SERVICES-MANAGEMENT SERVICES",
    },
    {
        code: "8742",
        desc: "SERVICES-MANAGEMENT CONSULTING SERVICES",
    },
    {
        code: "8744",
        desc: "SERVICES-FACILITIES SUPPORT MANAGEMENT SERVICES",
    },
    {
        code: "8880",
        desc: "AMERICAN DEPOSITARY RECEIPTS",
    },
    {
        code: "8888",
        desc: "FOREIGN GOVERNMENTS",
    },
    {
        code: "8900",
        desc: "SERVICES-SERVICES, NEC",
    },
    {
        code: "9721",
        desc: "INTERNATIONAL AFFAIRS",
    },
    {
        code: "9995",
        desc: "NON-OPERATING ESTABLISHMENTS",
    },
    {
        code: "0111",
        desc: "Wheat",
    },
    {
        code: "0112",
        desc: "Rice",
    },
    {
        code: "0115",
        desc: "Corn",
    },
    {
        code: "0116",
        desc: "Soybeans",
    },
    {
        code: "0119",
        desc: "Cash Grains, Not Elsewhere Classified",
    },
    {
        code: "0131",
        desc: "Cotton",
    },
    {
        code: "0132",
        desc: "Tobacco",
    },
    {
        code: "0133",
        desc: "Sugarcane and Sugar Beets",
    },
    {
        code: "0134",
        desc: "Irish Potatoes",
    },
    {
        code: "0139",
        desc: "Field Crops, Except Cash Grains, Not Elsewhere Classified",
    },
    {
        code: "0161",
        desc: "Vegetables and Melons",
    },
    {
        code: "0171",
        desc: "Berry Crops",
    },
    {
        code: "0172",
        desc: "Grapes",
    },
    {
        code: "0173",
        desc: "Tree Nuts",
    },
    {
        code: "0174",
        desc: "Citrus Fruits",
    },
    {
        code: "0175",
        desc: "Deciduous Tree Fruits",
    },
    {
        code: "0179",
        desc: "Fruits and Tree Nuts, Not Elsewhere Classified",
    },
    {
        code: "0181",
        desc: "Ornamental Floriculture and Nursery Products",
    },
    {
        code: "0182",
        desc: "Food Crops Grown Under Cover",
    },
    {
        code: "0191",
        desc: "General Farms, Primarily Crop",
    },
    {
        code: "0211",
        desc: "Beef Cattle Feedlots",
    },
    {
        code: "0212",
        desc: "Beef Cattle, Except Feedlots",
    },
    {
        code: "0213",
        desc: "Hogs",
    },
    {
        code: "0214",
        desc: "Sheep and Goats",
    },
    {
        code: "0219",
        desc: "General Livestock, Except Dairy and Poultry",
    },
    {
        code: "0241",
        desc: "Dairy Farms",
    },
    {
        code: "0251",
        desc: "Broiler, Fryer, and Roaster Chickens",
    },
    {
        code: "0252",
        desc: "Chicken Eggs",
    },
    {
        code: "0253",
        desc: "Turkeys and Turkey Eggs",
    },
    {
        code: "0254",
        desc: "Poultry Hatcheries",
    },
    {
        code: "0259",
        desc: "Poultry and Eggs, Not Elsewhere Classified",
    },
    {
        code: "0271",
        desc: "Fur-Bearing Animals and Rabbits",
    },
    {
        code: "0272",
        desc: "Horses and Other Equines",
    },
    {
        code: "0273",
        desc: "Animal Aquaculture",
    },
    {
        code: "0279",
        desc: "Animal Specialties, Not Elsewhere Classified",
    },
    {
        code: "0291",
        desc: "General Farms, Primarily Livestock and Animal Specialties",
    },
    {
        code: "0711",
        desc: "Soil Preparation Services",
    },
    {
        code: "0721",
        desc: "Crop Planting, Cultivating, and Protecting",
    },
    {
        code: "0722",
        desc: "Crop Harvesting, Primarily by Machine",
    },
    {
        code: "0723",
        desc: "Crop Preparation Services for Market",
    },
    {
        code: "0724",
        desc: "Cotton Ginning",
    },
    {
        code: "0741",
        desc: "Veterinary Services for Livestock",
    },
    {
        code: "0742",
        desc: "Veterinary Services for Animal Specialties",
    },
    {
        code: "0751",
        desc: "Livestock Services, Except Veterinary",
    },
    {
        code: "0752",
        desc: "Animal Specialty Services, Except Veterinary",
    },
    {
        code: "0761",
        desc: "Farm Labor Contractors and Crew Leaders",
    },
    {
        code: "0762",
        desc: "Farm Management Services",
    },
    {
        code: "0781",
        desc: "Landscape Counseling and Planning",
    },
    {
        code: "0782",
        desc: "Lawn and Garden Services",
    },
    {
        code: "0783",
        desc: "Ornamental Shrub and Tree Services",
    },
    {
        code: "0811",
        desc: "Timber Tracts",
    },
    {
        code: "0831",
        desc: "Forest Nurseries and Gathering of Forest Products",
    },
    {
        code: "0851",
        desc: "Forestry Services",
    },
    {
        code: "0912",
        desc: "Finfish",
    },
    {
        code: "0913",
        desc: "Shellfish",
    },
    {
        code: "0919",
        desc: "Miscellaneous Marine Products",
    },
    {
        code: "0921",
        desc: "Fish Hatcheries and Preserves",
    },
    {
        code: "0971",
        desc: "Hunting and Trapping, and Game Propagation",
    },
    {
        code: "1011",
        desc: "Iron Ores",
    },
    {
        code: "1021",
        desc: "Copper Ores",
    },
    {
        code: "1031",
        desc: "Lead and Zinc Ores",
    },
    {
        code: "1041",
        desc: "Gold Ores",
    },
    {
        code: "1044",
        desc: "Silver Ores",
    },
    {
        code: "1051",
        desc: "Bauxite and Other Aluminum Ores",
    },
    {
        code: "1061",
        desc: "Ferroalloy Ores, Except Vanadium",
    },
    {
        code: "1081",
        desc: "Metal Mining Services",
    },
    {
        code: "1092",
        desc: "Mercury Ores",
    },
    {
        code: "1094",
        desc: "Uranium-Radium-Vanadium Ores",
    },
    {
        code: "1099",
        desc: "Metal Ores, Not Elsewhere Classified",
    },
    {
        code: "1211",
        desc: "Bituminous Coal and Lignite Mining",
    },
    {
        code: "1231",
        desc: "Anthracite Mining",
    },
    {
        code: "1241",
        desc: "Coal Mining Services",
    },
    {
        code: "1321",
        desc: "Natural Gas Liquids",
    },
    {
        code: "1411",
        desc: "Dimension Stone",
    },
    {
        code: "1422",
        desc: "Crushed and Broken Limestone",
    },
    {
        code: "1423",
        desc: "Crushed and Broken Granite",
    },
    {
        code: "1429",
        desc: "Crushed and Broken Stone, Not Elsewhere Classified",
    },
    {
        code: "1442",
        desc: "Construction Sand and Gravel",
    },
    {
        code: "1446",
        desc: "Industrial Sand",
    },
    {
        code: "1455",
        desc: "Kaolin and Ball Clay",
    },
    {
        code: "1459",
        desc: "Clay, Ceramic, and Refractory Minerals, Not Elsewhere Classified",
    },
    {
        code: "1474",
        desc: "Potash, Soda, and Borate Minerals",
    },
    {
        code: "1475",
        desc: "Phosphate Rock",
    },
    {
        code: "1479",
        desc: "Chemical and Fertilizer Mineral Mining, Not Elsewhere Classified",
    },
    {
        code: "1481",
        desc: "Nonmetallic Minerals Services, Except Fuels",
    },
    {
        code: "1499",
        desc: "Miscellaneous Nonmetallic Minerals, Except Fuels",
    },
    {
        code: "1522",
        desc: "General Contractors-Residential Buildings, Other Than Single-Family",
    },
    {
        code: "1531",
        desc: "Operative Builders",
    },
    {
        code: "1542",
        desc: "General Contractors-Nonresidential Buildings, Other Than Industrial Buildings and Warehouses",
    },
    ,
    {
        code: "1622",
        desc: "Bridge, Tunnel, and Elevated Highway Construction",
    },
    {
        code: "1629",
        desc: "Heavy Construction, Not Elsewhere Classified",
    },
    {
        code: "1721",
        desc: "Painting and Paper Hanging",
    },
    ,
    {
        code: "1742",
        desc: "Plastering, Drywall, Acoustical, and Insulation Work",
    },
    {
        code: "1743",
        desc: "Terrazzo, Tile, Marble, and Mosaic Work",
    },
    {
        code: "1752",
        desc: "Floor Laying and Other Floor Work, Not Elsewhere Classified",
    },
    ,
    {
        code: "1781",
        desc: "Water Well Drilling",
    },
    {
        code: "1791",
        desc: "Structural Steel Erection",
    },
    {
        code: "1793",
        desc: "Glass and Glazing Work",
    },
    ,
    {
        code: "1794",
        desc: "Excavation Work",
    },
    {
        code: "1795",
        desc: "Wrecking and Demolition Work",
    },
    {
        code: "1796",
        desc: "Installation or Erection of Building Equipment, Not Elsewhere Classified",
    },
    {
        code: "2016",
        desc: "Poultry Dressing Plants",
    },
    {
        code: "2017",
        desc: "Poultry and Eggs, Not Elsewhere Classified",
    },
    {
        code: "2018",
        desc: "Prepared Fresh or Frozen Meat Products",
    },
    {
        code: "2019",
        desc: "Meat Products, Not Elsewhere Classified",
    },
    {
        code: "2021",
        desc: "Creamery Butter",
    },
    {
        code: "2022",
        desc: "Natural, Processed, and Imitation Cheese",
    },
    {
        code: "2023",
        desc: "Dry, Condensed, and Evaporated Dairy Products",
    },
    {
        code: "2026",
        desc: "Fluid Milk",
    },
    {
        code: "2027",
        desc: "Ice Cream and Frozen Desserts",
    },
    {
        code: "2028",
        desc: "Processed Cheese",
    },
    {
        code: "2032",
        desc: "Canned Specialties",
    },
    {
        code: "2034",
        desc: "Dried and Dehydrated Fruits, Vegetables, and Soup Mixes",
    },
    {
        code: "2035",
        desc: "Pickled Fruits and Vegetables, Vegetable Sauces and Seasonings",
    },
    {
        code: "2037",
        desc: "Frozen Fruits, Fruit Juices, and Vegetables",
    },
    {
        code: "2038",
        desc: "Frozen Specialties, Not Elsewhere Classified",
    },
    {
        code: "2039",
        desc: "Food Preparations, Not Elsewhere Classified",
    },
    {
        code: "2041",
        desc: "Flour and Other Grain Mill Products",
    },
    {
        code: "2043",
        desc: "Cereal Breakfast Foods",
    },
    {
        code: "2044",
        desc: "Rice Milling",
    },
    {
        code: "2045",
        desc: "Prepared Flour Mixes and Doughs",
    },
    {
        code: "2046",
        desc: "Wet Corn Milling",
    },
    {
        code: "2047",
        desc: "Dog and Cat Food",
    },
    {
        code: "2048",
        desc: "Prepared Feeds and Feed Ingredients for Animals and Fowls",
    },
    {
        code: "2051",
        desc: "Bread and Other Bakery Products, Except Cookies and Crackers",
    },
    {
        code: "2053",
        desc: "Frozen Bakery Products, Except Bread",
    },
    {
        code: "2061",
        desc: "Cane Sugar, Except Refining",
    },
    {
        code: "2062",
        desc: "Cane Sugar Refining",
    },
    {
        code: "2063",
        desc: "Beet Sugar",
    },
    {
        code: "2064",
        desc: "Candy and Other Confectionery Products",
    },
    {
        code: "2066",
        desc: "Chocolate and Cocoa Products",
    },
    {
        code: "2067",
        desc: "Chewing Gum",
    },
    {
        code: "2074",
        desc: "Cottonseed Oil Mills",
    },
    {
        code: "2075",
        desc: "Soybean Oil Mills",
    },
    {
        code: "2076",
        desc: "Vegetable Oil Mills, Except Corn, Cottonseed, and Soybean",
    },
    {
        code: "2077",
        desc: "Animal and Marine Fats and Oils",
    },
    {
        code: "2079",
        desc: "Shortening, Table Oils, Margarine, and Other Edible Fats and Oils",
    },
    {
        code: "2083",
        desc: "Malt",
    },
    {
        code: "2084",
        desc: "Wines, Brandy, and Brandy Spirits",
    },
    {
        code: "2085",
        desc: "Distilled and Blended Liquors",
    },
    {
        code: "2087",
        desc: "Flavoring Extracts and Flavoring Syrups",
    },
    {
        code: "2091",
        desc: "Canned and Cured Fish and Seafoods",
    },
    {
        code: "2095",
        desc: "Roasted Coffee",
    },
    {
        code: "2096",
        desc: "Potato Chips, Corn Chips, and Similar Snacks",
    },
    {
        code: "2097",
        desc: "Manufactured Ice",
    },
    {
        code: "2098",
        desc: "Macaroni, Spaghetti, Vermicelli, and Noodles",
    },
    {
        code: "2099",
        desc: "Food Preparations, Not Elsewhere Classified",
    },
    {
        code: "2121",
        desc: "Cigars",
    },
    {
        code: "2131",
        desc: "Chewing and Smoking Tobacco and Snuff",
    },
    {
        code: "2231",
        desc: "Broadwoven Fabric Mills, Wool (Including Dyeing and Finishing)",
    },
    {
        code: "2241",
        desc: "Narrow Fabric and Other Smallwares Mills: Cotton, Wool, Silk, and Manmade Fiber",
    },
    {
        code: "2251",
        desc: "Women’s Full-Length and Knee-Length Hosiery, Except Socks",
    },
    {
        code: "2252",
        desc: "Hosiery, Not Elsewhere Classified",
    },
    {
        code: "2254",
        desc: "Knit Underwear and Nightwear Mills",
    },
    {
        code: "2257",
        desc: "Weft Knit Fabric Mills",
    },
    {
        code: "2258",
        desc: "Lace and Warp Knit Fabric Mills",
    },
    {
        code: "2259",
        desc: "Knitting Mills, Not Elsewhere Classified",
    },
    {
        code: "2261",
        desc: "Finishing Plants, Cotton",
    },
    {
        code: "2262",
        desc: "Finishing Plants, Manmade Fiber and Silk",
    },
    {
        code: "2269",
        desc: "Finishing Plants, Not Elsewhere Classified",
    },
    {
        code: "2281",
        desc: "Yarn Spinning Mills",
    },
    {
        code: "2282",
        desc: "Yarn Texturizing, Throwing, Twisting, and Winding Mills",
    },
    {
        code: "2284",
        desc: "Thread Mills",
    },
    {
        code: "2295",
        desc: "Coated Fabrics, Not Rubberized",
    },
    {
        code: "2296",
        desc: "Tire Cord and Fabrics",
    },
    {
        code: "2297",
        desc: "Nonwoven Fabrics",
    },
    {
        code: "2298",
        desc: "Cordage and Twine",
    },
    {
        code: "2299",
        desc: "Textile Goods, Not Elsewhere Classified",
    },
    {
        code: "2311",
        desc: "Men’s and Boys’ Suits, Coats, and Overcoats",
    },
    {
        code: "2321",
        desc: "Men’s and Boys’ Shirts, Except Work Shirts",
    },
    {
        code: "2322",
        desc: "Men’s and Boys’ Underwear and Nightwear",
    },
    {
        code: "2323",
        desc: "Men’s and Boys’ Neckwear",
    },
    {
        code: "2325",
        desc: "Men’s and Boys’ Separate Trousers and Slacks",
    },
    {
        code: "2326",
        desc: "Men’s and Boys’ Work Clothing",
    },
    {
        code: "2329",
        desc: "Men’s and Boys’ Clothing, Not Elsewhere Classified",
    },
    {
        code: "2331",
        desc: "Women’s, Misses’, and Juniors’ Blouses and Shirts",
    },
    {
        code: "2335",
        desc: "Women’s, Misses’, and Juniors’ Dresses",
    },
    {
        code: "2337",
        desc: "Women’s, Misses’, and Juniors’ Suits, Skirts, and Coats",
    },
    {
        code: "2339",
        desc: "Women’s, Misses’, and Juniors’ Outerwear, Not Elsewhere Classified",
    },
    {
        code: "2341",
        desc: "Women’s, Misses’, Children’s, and Infants’ Underwear and Nightwear",
    },
    {
        code: "2342",
        desc: "Brassieres, Girdles, and Allied Garments",
    },
    {
        code: "2353",
        desc: "Hats, Caps, and Millinery",
    },
    {
        code: "2361",
        desc: "Girls’, Children’s, and Infants’ Dresses, Blouses, and Shirts",
    },
    {
        code: "2369",
        desc: "Girls’, Children’s, and Infants’ Outerwear, Not Elsewhere Classified",
    },
    {
        code: "2371",
        desc: "Fur Goods",
    },
    {
        code: "2381",
        desc: "Dress and Work Gloves, Except Knit and All-Leather",
    },
    {
        code: "2384",
        desc: "Robes and Dressing Gowns",
    },
    {
        code: "2385",
        desc: "Waterproof Outerwear",
    },
    {
        code: "2386",
        desc: "Leather and Sheep-Lined Clothing",
    },
    {
        code: "2387",
        desc: "Apparel Belts",
    },
    {
        code: "2389",
        desc: "Apparel and Accessories, Not Elsewhere Classified",
    },
    {
        code: "2391",
        desc: "Curtains and Draperies",
    },
    {
        code: "2392",
        desc: "Housefurnishings, Except Curtains and Draperies",
    },
    {
        code: "2393",
        desc: "Textile Bags",
    },
    {
        code: "2394",
        desc: "Canvas and Related Products",
    },
    {
        code: "2395",
        desc: "Pleating, Decorative and Novelty Stitching, and Tucking for the Trade",
    },
    {
        code: "2396",
        desc: "Automotive Trimmings, Apparel Findings, and Related Products",
    },
    {
        code: "2397",
        desc: "Schiffli Machine Embroideries",
    },
    {
        code: "2399",
        desc: "Fabricated Textile Products, Not Elsewhere Classified",
    },
    {
        code: "2411",
        desc: "Logging",
    },
    {
        code: "2426",
        desc: "Hardwood Dimension and Flooring Mills",
    },
    {
        code: "2429",
        desc: "Special Product Sawmills, Not Elsewhere Classified",
    },
    {
        code: "2431",
        desc: "Millwork",
    },
    {
        code: "2434",
        desc: "Wood Kitchen Cabinets",
    },
    {
        code: "2435",
        desc: "Hardwood Veneer and Plywood",
    },
    {
        code: "2436",
        desc: "Softwood Veneer and Plywood",
    },
    {
        code: "2439",
        desc: "Structural Wood Members, Not Elsewhere Classified",
    },
    {
        code: "2441",
        desc: "Nailed and Lock Corner Wood Boxes and Shook",
    },
    {
        code: "2448",
        desc: "Wood Pallets and Skids",
    },
    {
        code: "2449",
        desc: "Wood Containers, Not Elsewhere Classified",
    },
    {
        code: "2491",
        desc: "Wood Preserving",
    },
    {
        code: "2493",
        desc: "Reconstituted Wood Products",
    },
    {
        code: "2499",
        desc: "Wood Products, Not Elsewhere Classified",
    },
    {
        code: "2512",
        desc: "Upholstered Household Furniture",
    },
    {
        code: "2514",
        desc: "Metal Household Furniture",
    },
    {
        code: "2515",
        desc: "Mattresses, Foundations, and Convertible Beds",
    },
    {
        code: "2517",
        desc: "Wood Television, Radio, Phonograph, and Sewing Machine Cabinets",
    },
    {
        code: "2519",
        desc: "Household Furniture, Not Elsewhere Classified",
    },
    {
        code: "2521",
        desc: "Wood Office Furniture",
    },
    {
        code: "2541",
        desc: "Wood Office and Store Fixtures, Partitions, Shelving, and Lockers",
    },
    {
        code: "2542",
        desc: "Office and Store Fixtures, Partitions, Shelving, and Lockers, Except Wood",
    },
    {
        code: "2591",
        desc: "Drapery Hardware and Window Blinds and Shades",
    },
    {
        code: "2599",
        desc: "Furniture and Fixtures, Not Elsewhere Classified",
    },
    {
        code: "2641",
        desc: "Paper Coating and Laminating",
    },
    {
        code: "2646",
        desc: "Pressed and Molded Pulp Goods",
    },
    {
        code: "2652",
        desc: "Setup Paperboard Boxes",
    },
    {
        code: "2653",
        desc: "Corrugated and Solid Fiber Boxes",
    },
    {
        code: "2655",
        desc: "Fiber Cans, Tubes, Drums, and Similar Products",
    },
    {
        code: "2656",
        desc: "Sanitary Food Containers, Except Folding",
    },
    {
        code: "2657",
        desc: "Folding Paperboard Boxes, Including Sanitary",
    },
    {
        code: "2671",
        desc: "Packaging Paper and Plastics Film, Coated and Laminated",
    },
    {
        code: "2672",
        desc: "Coated and Laminated Paper, Not Elsewhere Classified",
    },
    {
        code: "2674",
        desc: "Uncoated Paper and Multiwall Bags",
    },
    {
        code: "2675",
        desc: "Die‑Cut Paper and Paperboard",
    },
    {
        code: "2676",
        desc: "Sanitary Paper Products",
    },
    {
        code: "2677",
        desc: "Envelopes",
    },
    {
        code: "2678",
        desc: "Stationery, Tablets, and Related Products",
    },
    {
        code: "2679",
        desc: "Converted Paper and Paperboard Products, Not Elsewhere Classified",
    },
    {
        code: "2721",
        desc: "Periodicals: Publishing, or Publishing and Printing",
    },
    {
        code: "2752",
        desc: "Commercial Printing, Lithographic",
    },
    {
        code: "2754",
        desc: "Commercial Printing, Gravure",
    },
    {
        code: "2759",
        desc: "Commercial Printing, Not Elsewhere Classified",
    },
    {
        code: "2782",
        desc: "Blankbooks, Looseleaf Binders, and Devices",
    },
    {
        code: "2789",
        desc: "Bookbinding and Related Work",
    },
    {
        code: "2791",
        desc: "Typesetting",
    },
    {
        code: "2796",
        desc: "Platemaking and Related Services",
    },
    {
        code: "2812",
        desc: "Alkalies and Chlorine",
    },
    {
        code: "2813",
        desc: "Industrial Gases",
    },
    {
        code: "2816",
        desc: "Inorganic Pigments",
    },
    {
        code: "2819",
        desc: "Industrial Inorganic Chemicals, Not Elsewhere Classified",
    },
    {
        code: "2822",
        desc: "Synthetic Rubber (Vulcanizable Elastomers)",
    },
    {
        code: "2823",
        desc: "Cellulosic Manmade Fibers",
    },
    {
        code: "2824",
        desc: "Organic Fibers, Noncellulosic",
    },
    {
        code: "2841",
        desc: "Soap and Other Detergents, Except Specialty Cleaners",
    },
    {
        code: "2843",
        desc: "Surface Active Agents, Finishing Agents, Sulfonated Oils, and Assistants",
    },
    {
        code: "2861",
        desc: "Gum and Wood Chemicals",
    },
    {
        code: "2865",
        desc: "Cyclic Organic Crudes and Intermediates, and Organic Dyes and Pigments",
    },
    {
        code: "2869",
        desc: "Industrial Organic Chemicals, Not Elsewhere Classified",
    },
    {
        code: "2873",
        desc: "Nitrogenous Fertilizers",
    },
    {
        code: "2874",
        desc: "Phosphatic Fertilizers",
    },
    {
        code: "2875",
        desc: "Fertilizers, Mixing Only",
    },
    {
        code: "2879",
        desc: "Pesticides and Agricultural Chemicals, Not Elsewhere Classified",
    },
    {
        code: "2892",
        desc: "Explosives",
    },
    {
        code: "2893",
        desc: "Printing Ink",
    },
    {
        code: "2895",
        desc: "Carbon Black",
    },
    {
        code: "2899",
        desc: "Chemicals and Chemical Preparations, Not Elsewhere Classified",
    },
    {
        code: "2951",
        desc: "Asphalt Paving Mixtures and Blocks",
    },
    {
        code: "2952",
        desc: "Asphalt Felts and Coatings",
    },
    {
        code: "2992",
        desc: "Lubricating Oils and Greases",
    },
    {
        code: "2999",
        desc: "Products of Petroleum and Coal, Not Elsewhere Classified",
    },
    {
        code: "3052",
        desc: "Rubber and Plastics Hose and Belting",
    },
    {
        code: "3053",
        desc: "Gaskets, Packing, and Sealing Devices",
    },
    {
        code: "3061",
        desc: "Molded, Extruded, and Lathe‑Cut Mechanical Rubber Goods",
    },
    {
        code: "3069",
        desc: "Fabricated Rubber Products, Not Elsewhere Classified",
    },
    {
        code: "3082",
        desc: "Unsupported Plastics Profile Shapes",
    },
    {
        code: "3083",
        desc: "Laminated Plastics Plate, Sheet, and Profile Shapes",
    },
    {
        code: "3084",
        desc: "Plastics Pipe",
    },
    {
        code: "3085",
        desc: "Plastics Bottles",
    },
    {
        code: "3087",
        desc: "Custom Compounding of Purchased Plastics Resins",
    },
    {
        code: "3088",
        desc: "Plastics Plumbing Fixtures",
    },
    {
        code: "3111",
        desc: "Leather Tanning and Finishing",
    },
    {
        code: "3131",
        desc: "Boot and Shoe Cut Stock and Findings",
    },
    {
        code: "3142",
        desc: "House Slippers",
    },
    {
        code: "3143",
        desc: "Men’s Footwear, Except Athletic",
    },
    {
        code: "3144",
        desc: "Women’s Footwear, Except Athletic",
    },
    {
        code: "3149",
        desc: "Footwear, Except Rubber, Not Elsewhere Classified",
    },
    {
        code: "3151",
        desc: "Leather Gloves and Mittens",
    },
    {
        code: "3161",
        desc: "Luggage",
    },
    {
        code: "3171",
        desc: "Handbags and Other Personal Leather Goods",
    },
    {
        code: "3172",
        desc: "Personal Leather Goods, Not Elsewhere Classified",
    },
    {
        code: "3199",
        desc: "Leather Goods, Not Elsewhere Classified",
    },
    {
        code: "3229",
        desc: "Pressed and Blown Glass, Not Elsewhere Classified",
    },
    {
        code: "3251",
        desc: "Brick and Structural Clay Tile",
    },
    {
        code: "3253",
        desc: "Ceramic Wall and Floor Tile",
    },
    {
        code: "3255",
        desc: "Clay Refractories",
    },
    {
        code: "3259",
        desc: "Structural Clay Products, Not Elsewhere Classified",
    },
    {
        code: "3261",
        desc: "Vitreous China Plumbing Fixtures and China and Earthenware Fittings",
    },
    {
        code: "3262",
        desc: "Vitreous China Table and Kitchen Articles",
    },
    {
        code: "3263",
        desc: "Fine Earthenware (Whiteware) Table and Kitchen Articles",
    },
    {
        code: "3264",
        desc: "Porcelain Electrical Supplies",
    },
    {
        code: "3269",
        desc: "Pottery Products, Not Elsewhere Classified",
    },
    {
        code: "3271",
        desc: "Concrete Block and Brick",
    },
    {
        code: "3273",
        desc: "Ready‑Mixed Concrete",
    },
    {
        code: "3274",
        desc: "Lime",
    },
    {
        code: "3275",
        desc: "Gypsum Products",
    },
    {
        code: "3291",
        desc: "Abrasive Products",
    },
    {
        code: "3292",
        desc: "Asbestos Products",
    },
    {
        code: "3295",
        desc: "Minerals and Earths, Ground or Otherwise Treated",
    },
    {
        code: "3296",
        desc: "Mineral Wool",
    },
    {
        code: "3297",
        desc: "Nonclay Refractories",
    },
    {
        code: "3299",
        desc: "Nonmetallic Mineral Products, Not Elsewhere Classified",
    },
    {
        code: "3313",
        desc: "Electrometallurgical Products, Except Steel",
    },
    {
        code: "3315",
        desc: "Steel Wire Drawing and Steel Nails and Spikes",
    },
    {
        code: "3316",
        desc: "Cold‑Rolled Steel Sheet, Strip, and Bars",
    },
    {
        code: "3321",
        desc: "Gray and Ductile Iron Foundries",
    },
    {
        code: "3322",
        desc: "Malleable Iron Foundries",
    },
    {
        code: "3324",
        desc: "Steel Investment Foundries",
    },
    {
        code: "3325",
        desc: "Steel Foundries, Not Elsewhere Classified",
    },
    {
        code: "3331",
        desc: "Primary Smelting and Refining of Copper",
    },
    {
        code: "3339",
        desc: "Primary Smelting and Refining of Nonferrous Metals, Not Elsewhere Classified",
    },
    {
        code: "3351",
        desc: "Rolling, Drawing, and Extruding of Copper",
    },
    {
        code: "3353",
        desc: "Aluminum Sheet, Plate, and Foil",
    },
    {
        code: "3354",
        desc: "Aluminum Extruded Products",
    },
    {
        code: "3355",
        desc: "Aluminum Rolling and Drawing, Not Elsewhere Classified",
    },
    {
        code: "3356",
        desc: "Rolling, Drawing, and Extruding of Nonferrous Metals, Except Copper and Aluminum",
    },
    {
        code: "3363",
        desc: "Aluminum Die‑Castings",
    },
    {
        code: "3364",
        desc: "Nonferrous Die‑Castings, Except Aluminum",
    },
    {
        code: "3365",
        desc: "Aluminum Foundries",
    },
    {
        code: "3366",
        desc: "Copper Foundries",
    },
    {
        code: "3369",
        desc: "Nonferrous Foundries, Except Aluminum and Copper",
    },
    {
        code: "3398",
        desc: "Metal Heat Treating",
    },
    {
        code: "3399",
        desc: "Primary Metal Products, Not Elsewhere Classified",
    },
    {
        code: "3421",
        desc: "Cutlery",
    },
    {
        code: "3423",
        desc: "Hand and Edge Tools, Except Machine Tools and Handsaws",
    },
    {
        code: "3425",
        desc: "Saw Blades and Handsaws",
    },
    {
        code: "3429",
        desc: "Hardware, Not Elsewhere Classified",
    },
    {
        code: "3431",
        desc: "Enameled Iron and Metal Sanitary Ware",
    },
    {
        code: "3432",
        desc: "Plumbing Fixture Fittings and Trim",
    },
    {
        code: "3441",
        desc: "Fabricated Structural Metal",
    },
    {
        code: "3446",
        desc: "Architectural and Ornamental Metal Work",
    },
    {
        code: "3449",
        desc: "Miscellaneous Structural Metal Work",
    },
    {
        code: "3462",
        desc: "Iron and Steel Forgings",
    },
    {
        code: "3463",
        desc: "Nonferrous Forgings",
    },
    {
        code: "3465",
        desc: "Automotive Stampings",
    },
    {
        code: "3466",
        desc: "Crowns and Closures",
    },
    {
        code: "3469",
        desc: "Metal Stampings, Not Elsewhere Classified",
    },
    {
        code: "3471",
        desc: "Electroplating, Plating, Polishing, Anodizing, and Coloring",
    },
    {
        code: "3479",
        desc: "Coating, Engraving, and Allied Services",
    },
    {
        code: "3482",
        desc: "Small Arms Ammunition",
    },
    {
        code: "3483",
        desc: "Ammunition, Except for Small Arms",
    },
    {
        code: "3484",
        desc: "Small Arms",
    },
    {
        code: "3489",
        desc: "Ordnance and Accessories, Not Elsewhere Classified",
    },
    {
        code: "3491",
        desc: "Industrial Valves",
    },
    {
        code: "3492",
        desc: "Fluid Power Valves and Hose Fittings",
    },
    {
        code: "3493",
        desc: "Steel Springs, Except Wire",
    },
    {
        code: "3494",
        desc: "Valves and Pipe Fittings, Not Elsewhere Classified",
    },
    {
        code: "3495",
        desc: "Wire Springs",
    },
    {
        code: "3496",
        desc: "Miscellaneous Fabricated Wire Products",
    },
    {
        code: "3497",
        desc: "Metal Foil and Leaf",
    },
    {
        code: "3498",
        desc: "Fabricated Pipe and Pipe Fittings",
    },
    {
        code: "3499",
        desc: "Fabricated Metal Products, Not Elsewhere Classified",
    },
    {
        code: "3511",
        desc: "Steam, Gas, and Hydraulic Turbines and Turbine Generator Sets",
    },
    {
        code: "3519",
        desc: "Internal Combustion Engines, Not Elsewhere Classified",
    },
    {
        code: "3535",
        desc: "Conveyors and Conveying Equipment",
    },
    {
        code: "3536",
        desc: "Hoists, Cranes, and Monorails",
    },
    {
        code: "3542",
        desc: "Machine Tools, Metal Forming Types",
    },
    {
        code: "3543",
        desc: "Industrial Patterns",
    },
    {
        code: "3544",
        desc: "Special Dies and Tools, Die Sets, Jigs and Fixtures, and Industrial Molds",
    },
    {
        code: "3545",
        desc: "Cutting Tools, Machine Tool Accessories, and Machinists’ Precision Measuring Devices",
    },
    {
        code: "3546",
        desc: "Power‑Driven Handtools",
    },
    {
        code: "3547",
        desc: "Rolling Mill Machinery and Equipment",
    },
    {
        code: "3548",
        desc: "Electric and Gas Welding and Soldering Equipment",
    },
    {
        code: "3549",
        desc: "Metalworking Machinery, Not Elsewhere Classified",
    },
    {
        code: "3552",
        desc: "Textile Machinery",
    },
    {
        code: "3553",
        desc: "Woodworking Machinery",
    },
    {
        code: "3554",
        desc: "Paper Industries Machinery",
    },
    {
        code: "3556",
        desc: "Food Products Machinery",
    },
    {
        code: "3563",
        desc: "Air and Gas Compressors",
    },
    {
        code: "3565",
        desc: "Packaging Machinery",
    },
    {
        code: "3566",
        desc: "Speed Changers, Industrial High‑Speed Drives, and Gears",
    },
    {
        code: "3568",
        desc: "Mechanical Power Transmission Equipment, Not Elsewhere Classified",
    },
    {
        code: "3581",
        desc: "Automatic Vending Machines",
    },
    {
        code: "3582",
        desc: "Commercial Laundry, Drycleaning, and Pressing Machines",
    },
    {
        code: "3586",
        desc: "Measuring and Dispensing Pumps",
    },
    {
        code: "3589",
        desc: "Service Industry Machinery, Not Elsewhere Classified",
    },
    {
        code: "3592",
        desc: "Carburetors, Pistons, Piston Rings, and Valves",
    },
    {
        code: "3593",
        desc: "Fluid Power Cylinders and Actuators",
    },
    {
        code: "3594",
        desc: "Fluid Power Pumps and Motors",
    },
    {
        code: "3596",
        desc: "Scales and Balances, Except Laboratory",
    },
    {
        code: "3599",
        desc: "Industrial and Commercial Machinery and Equipment, Not Elsewhere Classified",
    },
    {
        code: "3624",
        desc: "Carbon and Graphite Products",
    },
    {
        code: "3625",
        desc: "Relays and Industrial Controls",
    },
    {
        code: "3629",
        desc: "Electrical Industrial Apparatus, Not Elsewhere Classified",
    },
    {
        code: "3631",
        desc: "Household Cooking Equipment",
    },
    {
        code: "3632",
        desc: "Household Refrigerators and Home and Farm Freezers",
    },
    {
        code: "3633",
        desc: "Household Laundry Equipment",
    },
    {
        code: "3635",
        desc: "Household Vacuum Cleaners",
    },
    {
        code: "3639",
        desc: "Household Appliances, Not Elsewhere Classified",
    },
    {
        code: "3641",
        desc: "Electric Lamps",
    },
    {
        code: "3643",
        desc: "Current‑Carrying Wiring Devices",
    },
    {
        code: "3644",
        desc: "Noncurrent‑Carrying Wiring Devices",
    },
    {
        code: "3645",
        desc: "Residential Lighting Fixtures",
    },
    {
        code: "3646",
        desc: "Commercial, Industrial, and Institutional Electric Lighting Fixtures",
    },
    {
        code: "3647",
        desc: "Vehicular Lighting Equipment",
    },
    {
        code: "3648",
        desc: "Lighting Equipment, Not Elsewhere Classified",
    },
    {
        code: "3671",
        desc: "Electron Tubes",
    },
    {
        code: "3675",
        desc: "Electronic Capacitors",
    },
    {
        code: "3676",
        desc: "Electronic Resistors",
    },
    {
        code: "3691",
        desc: "Storage Batteries",
    },
    {
        code: "3692",
        desc: "Primary Batteries, Dry and Wet",
    },
    {
        code: "3694",
        desc: "Electrical Equipment for Internal Combustion Engines",
    },
    {
        code: "3699",
        desc: "Electrical Machinery, Equipment, and Supplies, Not Elsewhere Classified",
    },
    {
        code: "3731",
        desc: "Ship Building and Repairing",
    },
    {
        code: "3732",
        desc: "Boat Building and Repairing",
    },
    {
        code: "3761",
        desc: "Guided Missiles and Space Vehicles",
    },
    {
        code: "3764",
        desc: "Space Propulsion Units and Parts",
    },
    {
        code: "3769",
        desc: "Space Vehicle Equipment, Not Elsewhere Classified",
    },
    {
        code: "3792",
        desc: "Travel Trailers and Campers",
    },
    {
        code: "3795",
        desc: "Tanks and Tank Components",
    },
    {
        code: "3799",
        desc: "Transportation Equipment, Not Elsewhere Classified",
    },
    {
        code: "3914",
        desc: "Silverware, Plated Ware, and Stainless Steel Ware",
    },
    {
        code: "3915",
        desc: "Jewelers’ Findings and Materials, and Lapidary Work",
    },
    {
        code: "3951",
        desc: "Pens, Mechanical Pencils, and Parts",
    },
    {
        code: "3952",
        desc: "Lead Pencils, Crayons, and Artists’ Materials",
    },
    {
        code: "3953",
        desc: "Marking Devices",
    },
    {
        code: "3955",
        desc: "Carbon Paper and Inked Ribbons",
    },
    {
        code: "3961",
        desc: "Costume Jewelry and Costume Novelties",
    },
    {
        code: "3965",
        desc: "Fasteners, Buttons, Needles, and Pins",
    },
    {
        code: "3991",
        desc: "Brooms and Brushes",
    },
    {
        code: "3993",
        desc: "Signs and Advertising Displays",
    },
    {
        code: "3995",
        desc: "Burial Caskets",
    },
    {
        code: "3996",
        desc: "Hard Surface Floor Coverings, Not Elsewhere Classified",
    },
    {
        code: "3999",
        desc: "Manufacturing Industries, Not Elsewhere Classified",
    },
    {
        code: "4111",
        desc: "Local and Suburban Transit",
    },
    {
        code: "4119",
        desc: "Local Passenger Transportation, Not Elsewhere Classified",
    },
    {
        code: "4121",
        desc: "Taxicabs",
    },
    {
        code: "4131",
        desc: "Intercity & Rural Bus Transportation",
    },
    {
        code: "4141",
        desc: "Local Bus Charter Service",
    },
    {
        code: "4142",
        desc: "Bus Charter Service, Except Local",
    },
    {
        code: "4151",
        desc: "School Buses",
    },
    {
        code: "4173",
        desc: "Bus Terminal and Service Facilities",
    },
    {
        code: "4212",
        desc: "Local Trucking Without Storage",
    },
    {
        code: "4214",
        desc: "Local Trucking With Storage",
    },
    {
        code: "4215",
        desc: "Courier Services, Except by Air",
    },
    {
        code: "4221",
        desc: "Farm Product Warehousing and Storage",
    },
    {
        code: "4222",
        desc: "Refrigerated Warehousing and Storage",
    },
    {
        code: "4225",
        desc: "General Warehousing and Storage",
    },
    {
        code: "4226",
        desc: "Special Warehousing and Storage, Not Elsewhere Classified",
    },
    {
        code: "4311",
        desc: "United States Postal Service",
    },
    {
        code: "4424",
        desc: "Deep Sea Domestic Transportation of Freight",
    },
    {
        code: "4432",
        desc: "Freight Transportation on the Great Lakes–St. Lawrence Seaway",
    },
    {
        code: "4449",
        desc: "Water Transportation of Freight, Not Elsewhere Classified",
    },
    {
        code: "4481",
        desc: "Deep Sea Transportation of Passengers, Except Ferry",
    },
    {
        code: "4482",
        desc: "Ferries",
    },
    {
        code: "4489",
        desc: "Water Transportation of Passengers, Not Elsewhere Classified",
    },
    {
        code: "4491",
        desc: "Marine Cargo Handling",
    },
    {
        code: "4492",
        desc: "Towing and Tugboat Services",
    },
    {
        code: "4493",
        desc: "Marinas",
    },
    {
        code: "4499",
        desc: "Water Transportation Services, Not Elsewhere Classified",
    },
    {
        code: "4612",
        desc: "Crude Petroleum Pipelines",
    },
    {
        code: "4613",
        desc: "Refined Petroleum Pipelines",
    },
    {
        code: "4619",
        desc: "Pipelines, Not Elsewhere Classified",
    },
    {
        code: "4724",
        desc: "Travel Agencies",
    },
    {
        code: "4725",
        desc: "Tour Operators",
    },
    {
        code: "4729",
        desc: "Arrangement of Passenger Transportation, Not Elsewhere Classified",
    },
    {
        code: "4741",
        desc: "Rental of Railroad Cars",
    },
    {
        code: "4783",
        desc: "Packing and Crating",
    },
    {
        code: "4785",
        desc: "Fixed Facilities and Inspection and Weighing Services for Motor Vehicle Transportation",
    },
    {
        code: "4789",
        desc: "Transportation Services, Not Elsewhere Classified",
    },
    {
        code: "4925",
        desc: "Mixed, Manufactured, or Liquefied Petroleum Gas Production and/or Distribution",
    },
    {
        code: "4939",
        desc: "Combination Utilities, Not Elsewhere Classified",
    },
    {
        code: "4952",
        desc: "Sewerage Systems",
    },
    {
        code: "4959",
        desc: "Sanitary Services, Not Elsewhere Classified",
    },
    {
        code: "4971",
        desc: "Irrigation Systems",
    },
    {
        code: "5012",
        desc: "Automobiles and other motor vehicles",
    },
    {
        code: "5014",
        desc: "Tires and tubes",
    },
    {
        code: "5015",
        desc: "Motor vehicle parts, used",
    },
    {
        code: "5021",
        desc: "Furniture",
    },
    {
        code: "5023",
        desc: "Home furnishings",
    },
    {
        code: "5032",
        desc: "Brick, stone, and related construction materials",
    },
    {
        code: "5033",
        desc: "Roofing, siding, and insulation materials",
    },
    {
        code: "5039",
        desc: "Construction materials, not elsewhere classified",
    },
    {
        code: "5043",
        desc: "Photographic equipment and supplies",
    },
    {
        code: "5044",
        desc: "Office equipment",
    },
    {
        code: "5046",
        desc: "Commercial equipment, not elsewhere classified",
    },
    {
        code: "5048",
        desc: "Ophthalmic goods",
    },
    {
        code: "5049",
        desc: "Professional equipment and supplies, not elsewhere classified",
    },
    {
        code: "5052",
        desc: "Coal and other minerals and ores",
    },
    {
        code: "5074",
        desc: "Plumbing and heating equipment and supplies (hydronics)",
    },
    {
        code: "5075",
        desc: "Warm air heating and air‑conditioning equipment and supplies",
    },
    {
        code: "5078",
        desc: "Refrigeration equipment and supplies",
    },
    {
        code: "5083",
        desc: "Farm and garden machinery and equipments",
    },
    {
        code: "5085",
        desc: "Industrial supplies",
    },
    {
        code: "5087",
        desc: "Service establishment equipment and supplies",
    },
    {
        code: "5088",
        desc: "Transportation equipment and supplies, except motor vehicles",
    },
    {
        code: "5091",
        desc: "Sporting and recreational goods and supplies",
    },
    {
        code: "5092",
        desc: "Toys and hobby goods and supplies",
    },
    {
        code: "5093",
        desc: "Scrap and waste materials",
    },
    {
        code: "5111",
        desc: "Printing and writing paper",
    },
    {
        code: "5112",
        desc: "Stationery and office supplies",
    },
    {
        code: "5113",
        desc: "Industrial and personal service paper",
    },
    {
        code: "5131",
        desc: "Piece goods, notions, and other dry goods",
    },
    {
        code: "5136",
        desc: "Men’s and boys’ clothing and furnishings",
    },
    {
        code: "5137",
        desc: "Women’s, children’s, and infants’ clothing and accessories",
    },
    {
        code: "5139",
        desc: "Footwear",
    },
    {
        code: "5142",
        desc: "Packaged frozen foods",
    },
    {
        code: "5143",
        desc: "Dairy products, except dried or canned",
    },
    {
        code: "5144",
        desc: "Poultry and poultry products",
    },
    {
        code: "5145",
        desc: "Confectionery",
    },
    {
        code: "5146",
        desc: "Fish and seafoods",
    },
    {
        code: "5147",
        desc: "Meats and meat products",
    },
    {
        code: "5148",
        desc: "Fresh fruits and vegetables",
    },
    {
        code: "5149",
        desc: "Groceries and related products, not elsewhere classified",
    },
    {
        code: "5153",
        desc: "Grain and field beans",
    },
    {
        code: "5154",
        desc: "Livestock",
    },
    {
        code: "5159",
        desc: "Farm‑product raw materials, not elsewhere classified",
    },
    {
        code: "5162",
        desc: "Plastics materials and basic forms and shapes",
    },
    {
        code: "5169",
        desc: "Chemicals and allied products, not elsewhere classified",
    },
    {
        code: "5181",
        desc: "Beer and ale",
    },
    {
        code: "5182",
        desc: "Wine and distilled alcoholic beverages",
    },
    {
        code: "5191",
        desc: "Farm supplies",
    },
    {
        code: "5192",
        desc: "Books, periodicals, and newspapers",
    },
    {
        code: "5193",
        desc: "Flowers, nursery stock, and florists’ supplies",
    },
    {
        code: "5194",
        desc: "ITobacco and tobacco products",
    },
    {
        code: "5198",
        desc: "Paints, varnishes, and supplies",
    },
    {
        code: "5199",
        desc: "Nondurable goods, not elsewhere classified",
    },
    { code: "5211", desc: "Lumber and other building materials dealers" },
    { code: "5231", desc: "Paint, glass, and wallpaper stores" },
    { code: "5251", desc: "Hardware stores" },
    { code: "5261", desc: "Retail nurseries, lawn and garden supply stores" },
    { code: "5271", desc: "Mobile home dealers" },
    { code: "5311", desc: "Department stores" },
    { code: "5331", desc: "Variety stores" },
    { code: "5399", desc: "Miscellaneous general merchandise stores" },
    { code: "5411", desc: "Grocery stores" },
    {
        code: "5421",
        desc: "Meat and fish (seafood) markets, including freezer provisioners",
    },
    { code: "5431", desc: "Fruit and vegetable markets" },
    { code: "5441", desc: "Candy, nut, and confectionery stores" },
    { code: "5451", desc: "Dairy products stores" },
    { code: "5461", desc: "Retail bakeries" },
    { code: "5499", desc: "Miscellaneous food stores" },
    { code: "5511", desc: "Motor vehicle dealers (new and used)" },
    { code: "5521", desc: "Motor vehicle dealers (used only)" },
    { code: "5531", desc: "Auto and home supply stores" },
    { code: "5541", desc: "Gasoline service stations" },
    { code: "5551", desc: "Boat dealers" },
    { code: "5561", desc: "Recreational vehicle dealers" },
    { code: "5571", desc: "Motorcycle dealers" },
    { code: "5599", desc: "Automotive dealers, not elsewhere classified" },
    { code: "5611", desc: "Men’s and boys’ clothing and accessory stores" },
    { code: "5621", desc: "Women’s clothing stores" },
    { code: "5632", desc: "Women’s accessory and specialty stores" },
    { code: "5641", desc: "Children’s and infants’ wear stores" },
    { code: "5651", desc: "Family clothing stores" },
    { code: "5661", desc: "Shoe stores" },
    { code: "5699", desc: "Miscellaneous apparel and accessory stores" },
    { code: "5712", desc: "Furniture stores" },
    { code: "5713", desc: "Floor covering stores" },
    { code: "5714", desc: "Drapery, curtain, and upholstery stores" },
    { code: "5719", desc: "Miscellaneous home furnishings stores" },
    { code: "5722", desc: "Household appliance stores" },
    {
        code: "5731",
        desc: "Radio, television, and consumer electronics stores",
    },
    { code: "5734", desc: "Computer and computer software stores" },
    { code: "5735", desc: "Record and prerecorded tape stores" },
    { code: "5736", desc: "Musical instrument stores" },
    {
        code: "5812",
        desc: "Eating places (restaurants, cafés, fast‑food, carry‑out, caterers)",
    },
    {
        code: "5813",
        desc: "Drinking places (bars, pubs, cocktail lounges, nightclubs)",
    },
    { code: "5912", desc: "Drug stores and proprietary stores" },
    { code: "5921", desc: "Liquor stores" },
    { code: "5932", desc: "Used merchandise stores" },
    { code: "5941", desc: "Sporting goods stores and bicycle shops" },
    { code: "5942", desc: "Book stores" },
    { code: "5943", desc: "Stationery stores" },
    { code: "5944", desc: "Jewelry stores" },
    { code: "5945", desc: "Hobby, toy, and game shops" },
    { code: "5946", desc: "Camera and photographic supply stores" },
    { code: "5947", desc: "Gift, novelty, and souvenir shops" },
    { code: "5948", desc: "Luggage and leather goods stores" },
    { code: "5949", desc: "Sewing, needlework, and piece goods stores" },
    { code: "5961", desc: "Catalog and mail‑order houses" },
    {
        code: "5962",
        desc: "Automatic merchandising (vending) machine operators",
    },
    { code: "5963", desc: "Direct selling establishments" },
    { code: "5983", desc: "Fuel dealers (not elsewhere classified)" },
    { code: "5992", desc: "Florists" },
    { code: "5993", desc: "Tobacco stores and stands" },
    { code: "5994", desc: "News dealers and newsstands" },
    { code: "5995", desc: "Optical goods stores" },
    {
        code: "5999",
        desc: "Miscellaneous retail stores, not elsewhere classified",
    },
    { code: "6011", desc: "Federal Reserve Banks" },
    {
        code: "6019",
        desc: "Central Reserve Depository Institutions, Not Elsewhere Classified",
    },
    { code: "6061", desc: "Credit Unions, Federally Chartered" },
    { code: "6062", desc: "Credit Unions, Not Federally Chartered" },
    { code: "6081", desc: "Branches and Agencies of Foreign Banks" },
    {
        code: "6082",
        desc: "Foreign Trade and International Banking Institutions",
    },
    { code: "6091", desc: "Non‑deposit Trust Facilities" },
    { code: "6231", desc: "Security and commodity exchanges" },
    { code: "6371", desc: "Pension, health, and welfare funds" },
    {
        code: "6514",
        desc: "Operators of dwellings other than apartment buildings",
    },
    { code: "6515", desc: "Operators of residential mobile home sites" },
    { code: "6517", desc: "Lessors of railroad property" },
    { code: "6541", desc: "Title abstract offices" },
    { code: "6553", desc: "Cemetery subdividers and developers" },
    { code: "6712", desc: "Offices of Bank Holding Companies" },
    {
        code: "6719",
        desc: "Offices of Holding Companies, Not Elsewhere Classified",
    },
    { code: "6722", desc: "Management Investment Offices, Open‑End" },
    {
        code: "6726",
        desc: "Unit Investment Trusts, Face‑Amount Certificate Offices, and Closed‑End Management Investment Offices",
    },
    { code: "6732", desc: "Educational, Religious, and Charitable Trusts" },
    {
        code: "6733",
        desc: "Trusts, Except Educational, Religious, and Charitable",
    },
    { code: "7021", desc: "Rooming and Boarding Houses" },
    { code: "7032", desc: "Sporting and Recreational Camps" },
    { code: "7033", desc: "Recreational Vehicle Parks and Campsites" },
    {
        code: "7041",
        desc: "Organization Hotels and Lodging Houses, on Membership Basis",
    },
    { code: "7211", desc: "Power laundries, family and commercial" },
    {
        code: "7212",
        desc: "Garment pressing, and agents for laundries and drycleaners",
    },
    { code: "7213", desc: "Linen supply" },
    { code: "7215", desc: "Coin‑operated laundries and drycleaning" },
    { code: "7216", desc: "Drycleaning plants, except rug cleaning" },
    { code: "7217", desc: "Carpet and upholstery cleaning" },
    { code: "7218", desc: "Industrial launderers" },
    {
        code: "7219",
        desc: "Laundry and garment services, not elsewhere classified",
    },
    { code: "7221", desc: "Photographic studios, portrait" },
    { code: "7231", desc: "Beauty shops" },
    { code: "7241", desc: "Barber shops" },
    { code: "7251", desc: "Shoe repair shops and shoeshine parlors" },
    { code: "7261", desc: "Funeral service and crematories" },
    { code: "7291", desc: "Tax return preparation services" },
    {
        code: "7299",
        desc: "Miscellaneous personal services, not elsewhere classified",
    },
    { code: "7312", desc: "Outdoor advertising services" },
    {
        code: "7313",
        desc: "Radio, television, and publishers’ advertising representatives",
    },
    { code: "7319", desc: "Advertising, not elsewhere classified" },
    { code: "7322", desc: "Adjustment and collection services" },
    { code: "7323", desc: "Credit reporting services" },
    { code: "7334", desc: "Photocopying and duplicating services" },
    { code: "7335", desc: "Commercial photography" },
    { code: "7336", desc: "Commercial art and graphic design" },
    { code: "7338", desc: "Secretarial and court reporting services" },
    { code: "7342", desc: "Disinfecting and pest control services" },
    {
        code: "7349",
        desc: "Building cleaning and maintenance services, not elsewhere classified",
    },
    { code: "7352", desc: "Medical equipment rental and leasing" },
    { code: "7353", desc: "Heavy construction equipment rental and leasing" },
    { code: "7375", desc: "Information retrieval services" },
    { code: "7376", desc: "Computer facilities management services" },
    { code: "7378", desc: "Computer maintenance and repair" },
    {
        code: "7379",
        desc: "Computer‑related services, not elsewhere classified",
    },
    { code: "7382", desc: "Security systems services" },
    { code: "7383", desc: "News syndicates" },
    { code: "7513", desc: "Truck rental and leasing, without drivers" },
    { code: "7514", desc: "Passenger car rental" },
    { code: "7515", desc: "Passenger car leasing" },
    { code: "7521", desc: "Automobile parking" },
    {
        code: "7532",
        desc: "Top, body, and upholstery repair shops and paint shops",
    },
    { code: "7533", desc: "Automotive exhaust system repair shops" },
    { code: "7534", desc: "Tire retreading and repair shops" },
    { code: "7536", desc: "Automotive glass replacement shops" },
    { code: "7537", desc: "Automotive transmission repair shops" },
    { code: "7538", desc: "General automotive repair shops" },
    { code: "7539", desc: "Automotive repair shops, not elsewhere classified" },
    { code: "7542", desc: "Carwashes" },
    { code: "7549", desc: "Automotive services, not elsewhere classified" },
    { code: "7622", desc: "Radio and Television Repair Shops" },
    {
        code: "7623",
        desc: "Refrigeration and Air‑Conditioning Service and Repair Shops",
    },
    {
        code: "7629",
        desc: "Electrical and Electronic Repair Shops, Not Elsewhere Classified",
    },
    { code: "7631", desc: "Watch, Clock, and Jewelry Repair" },
    { code: "7641", desc: "Reupholstery and Furniture Repair" },
    { code: "7692", desc: "Welding Repair" },
    { code: "7694", desc: "Armature Rewinding Shops" },
    {
        code: "7699",
        desc: "Repair Shops and Related Services, Not Elsewhere Classified",
    },
    { code: "7832", desc: "Motion Picture Theaters, Except Drive‑In" },
    { code: "7833", desc: "Drive‑In Motion Picture Theaters" },
    { code: "7911", desc: "Dance Studios, Schools, and Halls" },
    {
        code: "7922",
        desc: "Theatrical Producers (Except Motion Picture) and Miscellaneous Theatrical Services",
    },
    {
        code: "7929",
        desc: "Bands, Orchestras, Actors, and Other Entertainers and Entertainment Groups",
    },
    { code: "7933", desc: "Bowling Centers" },
    { code: "7941", desc: "Professional Sports Clubs and Promoters" },
    { code: "7991", desc: "Physical Fitness Facilities" },
    { code: "7992", desc: "Public Golf Courses" },
    { code: "7996", desc: "Amusement Parks" },
    {
        code: "7999",
        desc: "Amusement and Recreation Services, Not Elsewhere Classified",
    },
    { code: "8021", desc: "Offices and Clinics of Dentists" },
    { code: "8031", desc: "Offices and Clinics of Doctors of Osteopathy" },
    { code: "8041", desc: "Offices and Clinics of Chiropractors" },
    { code: "8042", desc: "Offices and Clinics of Optometrists" },
    { code: "8043", desc: "Offices and Clinics of Podiatrists" },
    {
        code: "8049",
        desc: "Offices and Clinics of Health Practitioners, Not Elsewhere Classified",
    },
    { code: "8052", desc: "Intermediate Care Facilities" },
    {
        code: "8059",
        desc: "Nursing and Personal Care Facilities, Not Elsewhere Classified",
    },
    { code: "8063", desc: "Psychiatric Hospitals" },
    { code: "8069", desc: "Specialty Hospitals, Except Psychiatric" },
    { code: "8072", desc: "Dental Laboratories" },
    { code: "8092", desc: "Kidney Dialysis Centers" },
    {
        code: "8099",
        desc: "Health and Allied Services, Not Elsewhere Classified",
    },
    { code: "8211", desc: "Elementary and Secondary Schools" },
    { code: "8221", desc: "Colleges, Universities, and Professional Schools" },
    { code: "8222", desc: "Junior Colleges and Technical Institutes" },
    { code: "8231", desc: "Libraries" },
    { code: "8243", desc: "Data Processing Schools" },
    { code: "8244", desc: "Business and Secretarial Schools" },
    { code: "8249", desc: "Vocational Schools, Not Elsewhere Classified" },
    {
        code: "8299",
        desc: "Schools and Educational Services, Not Elsewhere Classified",
    },
    { code: "8322", desc: "Individual and Family Social Services" },
    {
        code: "8331",
        desc: "Job Training and Vocational Rehabilitation Services",
    },
    { code: "8361", desc: "Residential Care" },
    { code: "8399", desc: "Social Services, Not Elsewhere Classified" },
    { code: "8412", desc: "Museums and Art Galleries" },
    { code: "8422", desc: "Arboreta and Botanical or Zoological Gardens" },
    { code: "8611", desc: "Business Associations" },
    { code: "8621", desc: "Professional Membership Organizations" },
    { code: "8631", desc: "Labor Unions and Similar Labor Organizations" },
    { code: "8641", desc: "Civic, Social, and Fraternal Associations" },
    { code: "8651", desc: "Political Organizations" },
    { code: "8661", desc: "Religious Organizations" },
    {
        code: "8699",
        desc: "Membership Organizations, Not Elsewhere Classified",
    },
    { code: "8712", desc: "Architectural Services" },
    { code: "8713", desc: "Surveying Services" },
    { code: "8721", desc: "Accounting, Auditing, and Bookkeeping Services" },
    {
        code: "8732",
        desc: "Commercial Economic, Sociological, and Educational Research",
    },
    { code: "8733", desc: "Noncommercial Research Organizations" },
    { code: "8743", desc: "Public Relations Services" },
    {
        code: "8748",
        desc: "Business Consulting Services, Not Elsewhere Classified",
    },
    { code: "8811", desc: "Private Households" },
    { code: "8999", desc: "Services, Not Elsewhere Classified" },
    { code: "9111", desc: "Executive Offices" },
    { code: "9121", desc: "Legislative Bodies" },
    {
        code: "9131",
        desc: "Executive and Legislative Combined Offices, Except Finance",
    },
    { code: "9211", desc: "Courts" },
    { code: "9221", desc: "Police Protection" },
    { code: "9222", desc: "Legal Counsel and Prosecution" },
    { code: "9223", desc: "Correctional Institutions" },
    { code: "9224", desc: "Fire Protection" },
    { code: "9229", desc: "Public Order and Safety, Not Elsewhere Classified" },
    { code: "9311", desc: "Public Finance, Taxation, and Monetary Policy" },
    { code: "9411", desc: "Administration of Educational Programs" },
    { code: "9431", desc: "Administration of Public Health Programs" },
    {
        code: "9441",
        desc: "Administration of Social, Human Resource, and Income Maintenance Programs",
    },
    {
        code: "9451",
        desc: "Administration of Veterans’ Affairs, Except Health and Insurance",
    },
    { code: "9511", desc: "Air and Water Resource and Solid Waste Management" },
    { code: "9512", desc: "Land, Mineral, Wildlife, and Forest Conservation" },
    { code: "9531", desc: "Administration of Housing Programs" },
    {
        code: "9532",
        desc: "Administration of Urban Planning and Community and Rural Development",
    },
    { code: "9611", desc: "Administration of General Economic Programs" },
    {
        code: "9621",
        desc: "Regulation and Administration of Transportation Programs",
    },
    {
        code: "9631",
        desc: "Regulation and Administration of Communications, Electric, Gas, and Other Utilities",
    },
    {
        code: "9641",
        desc: "Regulation of Agricultural Marketing and Commodities",
    },
    {
        code: "9651",
        desc: "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors",
    },
    { code: "9711", desc: "National Security" },
    { code: "9999", desc: "Nonclassifiable Establishments" },
];
